(function () {
  // localStorage key for persisting shipping addresses
  const STORAGE_KEY = 'shopify_shipping_addresses';

  // Immediately restore from localStorage to prevent flash
  // This runs before DOMContentLoaded to set initial state
  (function restoreInitialState() {
    try {
      const savedData = localStorage.getItem(STORAGE_KEY);
      if (!savedData) return;
      
      const savedAddresses = JSON.parse(savedData);
      const selectedMethod =
        savedAddresses.selectedMethod === '邮编选址' || savedAddresses.japanAddressMode === 'postal'
          ? '邮编选址'
          : '日本选址';
      
      // Set radio button checked state before page renders
      const radios = document.querySelectorAll('input[type="radio"][name="attributes[Shipping method]"]');
      radios.forEach((radio) => {
        if (radio.value === selectedMethod) {
          radio.checked = true;
          radio.defaultChecked = true; // Also set defaultChecked to prevent reset
        }
      });
      
      // Set data attribute on container to indicate initial expanded state
      const container = document.querySelector('[data-cart-shipping-selector]');
      if (container) {
        const savedJapanAddress = savedAddresses.japanAddress;
        const savedJapanPostalCode = savedJapanAddress && savedJapanAddress.postalCode
          ? String(savedJapanAddress.postalCode).replace(/\D/g, '')
          : '';
        const hasValidJapanAddress =
          savedJapanAddress &&
          (!savedJapanAddress.postalCode || /^\d{7}$/.test(savedJapanPostalCode)) &&
          (savedJapanPostalCode || savedJapanAddress.fullAddress);
        const hasAddress = selectedMethod === '宅配'
          ? (savedAddresses.homeDelivery && (savedAddresses.homeDelivery.districtFull || savedAddresses.homeDelivery.road))
          : selectedMethod === '日本选址' || selectedMethod === '邮编选址'
            ? hasValidJapanAddress
            : (savedAddresses.convenienceStoreSelections && savedAddresses.convenienceStoreSelections[selectedMethod]);
        
        if (hasAddress) {
          container.setAttribute('data-has-saved-address', 'true');
        }
      }
    } catch (e) {
      // Ignore errors
    }
  })();

  const saveToLocalStorage = (addresses) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(addresses));
    } catch (error) {
      console.warn('Failed to save shipping addresses to localStorage:', error);
    }
  };

  const loadFromLocalStorage = () => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.warn('Failed to load shipping addresses from localStorage:', error);
      return null;
    }
  };

  const STORE_INDEX = {
    id: 0,
    name: 1,
    city: 2,
    districtFull: 3,
    road: 4,
    address: 5,
    // phone: 6,
  };

  const STORE_SEARCH_INDEX = {
    id: 0,
    name: 1,
    address: 2,
    fileName: 3,
  };

  const JAPAN_ADDRESS_INDEX = {
    postalCode: 0,
    province: 1,
    city: 2,
    district: 3,
  };

  const HOME_DELIVERY_METHOD = '宅配';
  const JAPAN_ADDRESS_METHOD = '日本选址';
  const JAPAN_POSTAL_ADDRESS_METHOD = '邮编选址';
  const JAPAN_ADDRESS_MODE_ADDRESS = 'address';
  const JAPAN_ADDRESS_MODE_POSTAL = 'postal';
  const JAPAN_UNLISTED_DISTRICT_LABEL = '以下に掲載がない場合';

  const METHOD_CONFIG = {
    '7-11': {
      chainKey: 'seven',
      label: '7-11',
      pickerTitle: '更換門市',
      pickerStatus: '7-11 門市查詢',
      addLabel: '+新增 7-11 地址',
      changeLabel: '更換 7-11 門市',
      emptyTitle: '尚未選擇 7-11 門市',
      emptyHint: '點擊上方按鈕後，於右側視窗選擇 7-11 門市。',
    },
    全家: {
      chainKey: 'family',
      label: '全家',
      pickerTitle: '更換門市',
      pickerStatus: '全家 門市查詢',
      addLabel: '+新增 全家 地址',
      changeLabel: '更換 全家 門市',
      emptyTitle: '尚未選擇全家門市',
      emptyHint: '點擊上方按鈕後，於右側視窗選擇全家門市。',
    },
    宅配: {
      label: '宅配',
      pickerTitle: '選擇宅配地址',
      pickerStatus: '請逐級選擇縣市、鄉鎮區與街道',
      addLabel: '+新增宅配地址',
      changeLabel: '更換宅配地址',
      emptyTitle: '尚未選擇宅配地址',
      emptyHint: '點擊上方按鈕後，於右側視窗逐級選擇地址。',
    },
    日本选址: {
      label: '住所選択',
      pickerTitle: '住所を選択',
      pickerStatus: '都道府県→市区町村→町域を順に選択',
      addLabel: '+住所を選択',
      changeLabel: '+住所を選択',
      emptyTitle: '住所未選択',
      emptyHint: '上部ボタンを押し、右ウィンドウで住所を段階選択してください。',
    },
    邮编选址: {
      label: '邮编选址',
      pickerTitle: '郵編選址',
      pickerStatus: '請輸入 7 位郵編搜尋日本地址',
      addLabel: '',
      changeLabel: '',
      emptyTitle: '尚未完成郵編選址',
      emptyHint: '請輸入 7 位郵編並點擊住所検索。',
    },
  };

  const CONVENIENCE_STORE_METHODS = [];
  const PICKER_INDEX_PREFETCH_METHODS = [JAPAN_ADDRESS_METHOD];

  const storeDataPromises = new Map();
  let initFrame = null;
  const isHomeDeliveryMethod = (method) => method === HOME_DELIVERY_METHOD;
  const isJapanPostalAddressMethod = (method) => method === JAPAN_POSTAL_ADDRESS_METHOD;
  const isJapanAddressMethod = (method) => method === JAPAN_ADDRESS_METHOD || isJapanPostalAddressMethod(method);
  const isAddressDeliveryMethod = (method) => isHomeDeliveryMethod(method) || isJapanAddressMethod(method);

  const toHalfWidth = (value) =>
    String(value || '')
      .replace(/[\uFF01-\uFF5E]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 65248))
      .replace(/\u3000/g, ' ');

  const normalizeText = (value) => toHalfWidth(value).replace(/台/g, '臺').replace(/\s+/g, '').toLowerCase();
  const normalizePostalCode = (value) => toHalfWidth(value).replace(/\D/g, '').slice(0, 7);

  const normalizeContactName = (value) =>
    toHalfWidth(value)
      .trim()
      .replace(/\s+/g, ' ');

  const normalizeJapanPhone = (value) => {
    let normalized = toHalfWidth(value)
      .trim()
      // 半角・全角スペース、括弧、各種ハイフン、ピリオドを除去する。
      .replace(/[\s().（）\[\]\-‐‑‒–—―ー−.]/g, '');

    // 国際形式 0081 / 81 / +810 を、+81（国内先頭の0を除く）へ統一する。
    if (normalized.startsWith('0081')) normalized = `+81${normalized.slice(4)}`;
    if (/^81\d/.test(normalized)) normalized = `+${normalized}`;
    if (normalized.startsWith('+810')) normalized = `+81${normalized.slice(4)}`;

    return normalized;
  };

  const toJapanDomesticPhone = (value) => {
    const phone = normalizeJapanPhone(value);

    // +81 形式は、判定時だけ国内形式の先頭0へ戻す。
    if (/^\+81[1-9]\d{8,9}$/.test(phone)) {
      return `0${phone.slice(3)}`;
    }

    return /^0\d+$/.test(phone) ? phone : '';
  };

  const isValidJapanPhone = (value) => {
    const phone = toJapanDomesticPhone(value);
    if (!phone) return false;

    // 携帯電話：070 / 080 / 090 + 8桁（合計11桁）
    // 060は2026年7月時点で提供開始が延期されているため、現時点では含めない。
    if (/^(?:070|080|090)\d{8}$/.test(phone)) return true;

    // IP電話：050 + 8桁（合計11桁）
    if (/^050\d{8}$/.test(phone)) return true;

    // フリーダイヤル：0800 + 7桁（合計11桁）
    if (/^0800\d{7}$/.test(phone)) return true;

    // 0120 / 0570 / 0990：4桁プレフィックス + 6桁（合計10桁）
    if (/^(?:0120|0570|0990)\d{6}$/.test(phone)) return true;

    // 固定電話：市外局番から始まる合計10桁。
    // 010（国際電話識別）、020（データ通信）、050/070/080/090の桁不足は除外する。
    if (/^0[1-9]\d{8}$/.test(phone) && !/^(?:010|020|050|070|080|090)/.test(phone)) {
      return true;
    }

    return false;
  };


  const isValidEmail = (value) => {
  const email = String(value || '').trim().toLowerCase();

  if (!email || email.length > 254 || email.includes('..')) return false;

  const atIndex = email.lastIndexOf('@');

  if (atIndex <= 0 || atIndex !== email.indexOf('@')) return false;

  const localPart = email.slice(0, atIndex);
  const domain = email.slice(atIndex + 1);

  if (localPart.length > 64 || !domain || domain.length > 253) return false;


  // 新增：
  // 拦截 @ 后面全部为数字且没有域名后缀的情况
  // 例如：123@123
  // 不影响：123@123.com
  if (/^\d+$/.test(domain)) return false;


  if (!/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/i.test(localPart)) return false;

  if (localPart.startsWith('.') || localPart.endsWith('.')) return false;


  const labels = domain.split('.');

  if (labels.length < 2) return false;


  const validDomainLabel = (label) =>
    /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i.test(label);


  if (!labels.every(validDomainLabel)) return false;


  const topLevelDomain = labels[labels.length - 1];

  const isValidTopLevelDomain =
    /^[a-z]{2,24}$/i.test(topLevelDomain) ||
    /^xn--[a-z0-9-]{2,59}$/i.test(topLevelDomain);


  if (!isValidTopLevelDomain) return false;


  return true;
};


  const splitRecipientName = (value) => {
    const name = normalizeContactName(value);
    if (!name) return { firstName: '', lastName: '' };

    const parts = name.split(' ').filter(Boolean);
    if (parts.length > 1) {
      return { lastName: parts[0], firstName: parts.slice(1).join(' ') };
    }

    const compactName = name.replace(/\s+/g, '');
    if (/^[\u3040-\u30ff\u3400-\u9fff々〆ヵヶー・]+$/.test(compactName) && compactName.length >= 2) {
      return { lastName: compactName.slice(0, 1), firstName: compactName.slice(1) };
    }

    return { lastName: name, firstName: '' };
  };


  const clearChildren = (node) => {
    while (node && node.firstChild) {
      node.removeChild(node.firstChild);
    }
  };

  const getMethodConfig = (method) => METHOD_CONFIG[method] || METHOD_CONFIG[JAPAN_ADDRESS_METHOD];

  const loadStoreData = (url) => {
    if (!url) return Promise.reject(new Error('Missing store picker data URL'));

    if (!storeDataPromises.has(url)) {
      const promise = fetch(url, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(`Failed to load store picker data: ${response.status}`);
          return response.json();
        })
        .catch((error) => {
          storeDataPromises.delete(url);
          throw error;
        });

      storeDataPromises.set(url, promise);
    }

    return storeDataPromises.get(url);
  };

  const getStorePickerAssetBaseUrl = (picker) => {
    const explicitBaseUrl = picker && picker.dataset.storePickerAssetsBaseUrl;
    if (explicitBaseUrl) return explicitBaseUrl;

    const sampleUrl =
      (picker && (picker.dataset.storePickerDeliveryUrl || picker.dataset.storePickerSevenUrl || picker.dataset.storePickerFamilyUrl || picker.dataset.storePickerUrl)) ||
      '';
    const cleanUrl = sampleUrl.split('?')[0];

    return cleanUrl.slice(0, cleanUrl.lastIndexOf('/') + 1);
  };

  const buildStorePickerAssetUrl = (picker, fileName) => `${getStorePickerAssetBaseUrl(picker)}${fileName}`;

  const getMethodDataUrl = (picker, method) => {
    if (isJapanAddressMethod(method)) {
      return picker.dataset.storePickerJapanUrl || picker.dataset.storePickerUrl;
    }

    if (isHomeDeliveryMethod(method)) {
      return picker.dataset.storePickerDeliveryUrl || picker.dataset.storePickerUrl;
    }

    const config = getMethodConfig(method);

    if (config.chainKey === 'family') {
      return picker.dataset.storePickerFamilyUrl || picker.dataset.storePickerUrl;
    }

    return picker.dataset.storePickerSevenUrl || picker.dataset.storePickerUrl;
  };

  const normalizeMethodData = (method, data) => {
    if (isJapanAddressMethod(method)) {
      const japan = data.japan || data;

      return {
        japan: {
          ...japan,
          addressesByProvince: {},
          districtsByCity: japan.districtsByCity || {},
        },
      };
    }

    if (isHomeDeliveryMethod(method)) {
      const delivery = data.delivery || data;

      return {
        delivery: {
          ...delivery,
          roadsByDistrict: delivery.roadsByDistrict || {},
        },
      };
    }

    const config = getMethodConfig(method);
    const chain = data.chains ? data.chains[config.chainKey] : data[config.chainKey] || data;

    return {
      chains: {
        [config.chainKey]: chain,
      },
    };
  };

  const loadMethodData = (picker, method) => loadStoreData(getMethodDataUrl(picker, method)).then((data) => normalizeMethodData(method, data));

  const loadJapanPostalIndex = (picker) => {
    const url = picker && picker.dataset.storePickerJapanPostalIndexUrl;
    return url ? loadStoreData(url) : Promise.resolve(null);
  };

  const prefetchMethodIndexes = (picker, priorityMethod) => {
    const methods = [priorityMethod, ...PICKER_INDEX_PREFETCH_METHODS].filter(Boolean);
    const seenUrls = new Set();

    methods.forEach((method) => {
      const url = getMethodDataUrl(picker, method);
      if (!url || seenUrls.has(url)) return;

      seenUrls.add(url);
      loadStoreData(url).catch((error) => {
        console.warn(`Failed to preload ${method} picker index:`, error);
      });
    });
  };

  const hasDeliveryRoadsForCity = (delivery, city) => {
    if (!delivery || !city) return false;
    const districts = delivery.districtsByCity ? delivery.districtsByCity[city] || [] : [];

    if (!districts.length) return false;
    if (!delivery.roadsByDistrict) return false;

    return districts.every(([, districtFull]) => Object.prototype.hasOwnProperty.call(delivery.roadsByDistrict, districtFull));
  };

  const hasAllDeliveryRoads = (delivery) => Boolean(delivery && delivery.cities && delivery.cities.every((city) => hasDeliveryRoadsForCity(delivery, city)));

  function buildChoiceButton(text, isActive, onClick) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `cart-store-picker__choice${isActive ? ' is-active' : ''}`;
    button.textContent = text;
    button.addEventListener('click', onClick);
    return button;
  }

  function buildEmptyMessage(text) {
    const empty = document.createElement('p');
    empty.className = 'cart-store-picker__empty';
    empty.textContent = text;
    return empty;
  }

  function buildStep(title, options = {}) {
    if (typeof options === 'boolean' || typeof options === 'number') {
      options = { columns: options };
    }

    const { columns = 1, isExpanded = true, summary = '', onToggle = null } = options;
    const step = document.createElement('section');
    step.className = `cart-store-picker__step${isExpanded ? ' is-expanded' : ''}`;

    const heading = document.createElement('button');
    heading.type = 'button';
    heading.className = 'cart-store-picker__step-title';
    heading.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

    if (typeof onToggle === 'function') {
      heading.addEventListener('click', onToggle);
    }

    const headingContent = document.createElement('span');
    headingContent.className = 'cart-store-picker__step-title-content';

    const headingLabel = document.createElement('span');
    headingLabel.className = 'cart-store-picker__step-label';
    headingLabel.textContent = title;
    headingContent.appendChild(headingLabel);

    if (summary) {
      const headingSummary = document.createElement('span');
      headingSummary.className = 'cart-store-picker__step-summary';
      headingSummary.textContent = summary;
      headingContent.appendChild(headingSummary);
    }

    const headingIcon = document.createElement('span');
    headingIcon.className = 'cart-store-picker__step-icon';
    headingIcon.setAttribute('aria-hidden', 'true');
    headingIcon.textContent = isExpanded ? '−' : '+';

    heading.appendChild(headingContent);
    heading.appendChild(headingIcon);

    // Map columns to class name (1-4)
    const columnClass = {
      1: 'cart-store-picker__step-body cart-store-one-picker__step-body',
      2: 'cart-store-picker__step-body cart-store-two-picker__step-body',
      3: 'cart-store-picker__step-body cart-store-three-picker__step-body',
      4: 'cart-store-picker__step-body',
    }[Math.min(Math.max(columns, 1), 4)] || 'cart-store-picker__step-body';

    const body = document.createElement('div');
    body.className = columnClass;
    body.hidden = !isExpanded;

    step.appendChild(heading);
    step.appendChild(body);

    return { step, body, heading };
  }

  function buildStoreButton(store, onSelect) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'cart-store-picker__store';

    const title = document.createElement('div');
    title.className = 'cart-store-picker__store-title';
    title.textContent = `${store[STORE_INDEX.name]} (${store[STORE_INDEX.id]})`;

    // const meta = document.createElement('div');
    // meta.className = 'cart-store-picker__store-meta';
    // meta.textContent = store[STORE_INDEX.phone] ? `電話 ${store[STORE_INDEX.phone]}` : ' ';

    const address = document.createElement('div');
    address.className = 'cart-store-picker__store-address';
    address.textContent = store[STORE_INDEX.address];

    button.appendChild(title);
    // button.appendChild(meta);
    button.appendChild(address);
    button.addEventListener('click', () => onSelect(store));

    return button;
  }

  function initRoot(root) {
    if (!root || root.dataset.storePickerBound === 'true') return;
    root.dataset.storePickerBound = 'true';

    const detail = root.querySelector('[data-shipping-detail]');
    const optionRows = Array.from(root.querySelectorAll('[data-shipping-option]'));
    const radios = optionRows.map((row) => row.querySelector('input[type="radio"]')).filter(Boolean);
    const triggerButtons = Array.from(root.querySelectorAll('[data-shipping-trigger]'));
    const storeField = root.querySelector('[data-shipping-store-field]');
    const homeField = root.querySelector('[data-shipping-home-field]');
    const hint = root.querySelector('[data-shipping-hint]');

    const selectedStoreCard = root.querySelector('[data-selected-store]');
    const selectedStoreTitle = root.querySelector('[data-selected-store-title]');
    const selectedStoreMeta = root.querySelector('[data-selected-store-meta]');
    const selectedStoreAddress = root.querySelector('[data-selected-store-address]');
    const storeChainInput = root.querySelector('[data-store-chain-input]');
    const storeNameInput = root.querySelector('[data-store-name-input]');
    const storeCodeInput = root.querySelector('[data-store-code-input]');
    const storeAddressInput = root.querySelector('[data-store-address-input]');
    // const storePhoneInput = root.querySelector('[data-store-phone-input]');
    const storeCityInput = root.querySelector('[data-store-city-input]');
    const storeDistrictInput = root.querySelector('[data-store-district-input]');
    const storeRoadInput = root.querySelector('[data-store-road-input]');

    const selectedHomeCard = root.querySelector('[data-selected-home]');
    const selectedHomeTitle = root.querySelector('[data-selected-home-title]');
    const selectedHomeMeta = root.querySelector('[data-selected-home-meta]');
    const selectedHomeAddress = root.querySelector('[data-selected-home-address]');
    const japanProvinceDisplay = root.querySelector('[data-japan-province-display]');
    const japanCityDisplay = root.querySelector('[data-japan-city-display]');
    const japanTownDisplay = root.querySelector('[data-japan-town-display]');
    const japanPostalDisplay = root.querySelector('[data-japan-postal-display]');
    const homeDetailInput = root.querySelector('[data-home-detail-input]');
    const deliveryCityInput = root.querySelector('[data-delivery-city-input]');
    const deliveryDistrictInput = root.querySelector('[data-delivery-district-input]');
    const deliveryRoadInput = root.querySelector('[data-delivery-road-input]');
    const deliveryPostalCodeInput = root.querySelector('[data-delivery-postal-code-input]');
    const deliveryPostalCodeSearchButton = root.querySelector('[data-delivery-postal-code-search]');
    const japanPostalRow = root.querySelector('[data-japan-postal-row]');
    const japanPostalNotes = root.querySelector('[data-japan-postal-notes]');
    const japanPostalMessage = root.querySelector('[data-japan-postal-message]');
    const deliveryAddressInput = root.querySelector('[data-delivery-address-input]');
    const shippingSummaryInput = root.querySelector('[data-shipping-summary-input]');
    // const checkoutCompanyInput = root.querySelector('[data-checkout-company-input]');
    const checkoutAddress1Input = root.querySelector('[data-checkout-address1-input]');
    const checkoutCityInput = root.querySelector('[data-checkout-city-input]');
    const checkoutProvinceInput = root.querySelector('[data-checkout-province-input]');
    const checkoutZipInput = root.querySelector('[data-checkout-zip-input]');
    const checkoutCountryInput = root.querySelector('[data-checkout-country-input]');

    const contactNameInput = root.querySelector('[data-contact-name-input]');
    const contactPhoneInput = root.querySelector('[data-contact-phone-input]');
    const contactEmailInput = root.querySelector('[data-contact-email-input]');
    const checkoutFirstNameInput = root.querySelector('[data-checkout-first-name-input]');
    const checkoutLastNameInput = root.querySelector('[data-checkout-last-name-input]');
    const contactSummaryError = root.querySelector('[data-contact-summary-error]');
    const cartForm = document.getElementById('cart');
    const checkoutButtons = Array.from(
      document.querySelectorAll('[data-checkout-button], button[name="checkout"][form="cart"], #cart button[name="checkout"]')
    );

    const picker = root.querySelector('[data-store-picker]');
    const pickerPanel = root.querySelector('[data-store-picker-panel]');

    // Helper functions needed before localStorage restoration
    const getMethodConfig = (method) => METHOD_CONFIG[method] || METHOD_CONFIG[JAPAN_ADDRESS_METHOD];
    
    const getConvenienceStoreSummary = (method) => {
      return normalizeConvenienceStoreSummary(method, state.convenienceStoreSelections[method]);
    };

    const getHomeSummary = () => {
      const districtFull = deliveryDistrictInput ? deliveryDistrictInput.value.trim() : '';
      const road = deliveryRoadInput ? deliveryRoadInput.value.trim() : '';
      const postalCode = deliveryPostalCodeInput ? deliveryPostalCodeInput.value.trim() : '';
      const detailText = homeDetailInput ? homeDetailInput.value.trim() : '';
      const fullAddress = deliveryAddressInput ? deliveryAddressInput.value.trim() : '';
      const city = deliveryCityInput ? deliveryCityInput.value.trim() : '';

      if (!districtFull && !road && !detailText && !fullAddress && !postalCode) return null;

      return {
        city,
        districtFull,
        road,
        postalCode,
        detail: detailText,
        fullAddress,
      };
    };

    const buildJapanCityFull = (province, city) => {
      const provinceText = String(province || '').trim();
      const cityText = String(city || '').trim();

      if (!cityText) return '';
      if (provinceText && cityText.startsWith(provinceText)) return cityText;

      return provinceText ? `${provinceText}${cityText}` : cityText;
    };

    const getJapanCityName = (province, cityFull, city) => {
      const provinceText = String(province || '').trim();
      const cityText = String(city || '').trim();
      const cityFullText = String(cityFull || '').trim();

      if (cityText) {
        return provinceText && cityText.startsWith(provinceText) ? cityText.slice(provinceText.length) : cityText;
      }

      if (provinceText && cityFullText.startsWith(provinceText)) {
        return cityFullText.slice(provinceText.length);
      }

      return cityFullText;
    };

    const buildJapanFullAddress = (province, city, district) =>
      `${String(province || '').trim()}${String(city || '').trim()}${String(district || '').trim()}`;

    const syncJapanPostalInputs = (postalCode, source = null) => {
      const normalizedPostalCode = normalizePostalCode(postalCode);

      if (japanPostalDisplay && source !== japanPostalDisplay && japanPostalDisplay.value !== normalizedPostalCode) {
        japanPostalDisplay.value = normalizedPostalCode;
      }

      if (deliveryPostalCodeInput && source !== deliveryPostalCodeInput && deliveryPostalCodeInput.value !== normalizedPostalCode) {
        deliveryPostalCodeInput.value = normalizedPostalCode;
      }

      return normalizedPostalCode;
    };

    const getCurrentJapanPostalCode = () => {
      const displayPostalCode = japanPostalDisplay ? normalizePostalCode(japanPostalDisplay.value) : '';
      const searchPostalCode = deliveryPostalCodeInput ? normalizePostalCode(deliveryPostalCodeInput.value) : '';

      return displayPostalCode || searchPostalCode;
    };

    const normalizeJapanAddressSummary = (summary) => {
      if (!summary) return null;

      const postalCode = normalizePostalCode(summary.postalCode || '');
      const explicitProvince = String(summary.province || summary.prefecture || '').trim();
      const cityFull = String(summary.cityFull || summary.districtFull || '').trim();
      const explicitCity = String(summary.japanCity || summary.cityName || '').trim();
      const legacyCity = String(summary.city || '').trim();
      const province =
        explicitProvince ||
        (legacyCity && cityFull.startsWith(legacyCity) ? legacyCity : !explicitCity && !cityFull ? legacyCity : '');
      let city = getJapanCityName(province, cityFull, explicitCity || (explicitProvince ? legacyCity : ''));
      const district = String(summary.district || summary.road || '').trim();
      const detailText = String(summary.detail || '').trim();

      if (city === province) {
        city = '';
      }

      if (province && city.startsWith(province)) {
        city = city.slice(province.length);
      }

      const normalizedCityFull = cityFull || buildJapanCityFull(province, city);
      const fullAddress = String(summary.fullAddress || '').trim() || buildJapanFullAddress(province, city, district);

      if (!postalCode && !province && !city && !district && !fullAddress && !detailText) return null;

      return {
        postalCode,
        province,
        city,
        cityFull: normalizedCityFull,
        district,
        districtFull: fullAddress,
        fullAddress,
        detail: detailText,
      };
    };

    const getJapanAddressSummary = () => {
      const current = state.japanAddress || {};
      const displayProvince = japanProvinceDisplay ? japanProvinceDisplay.value.trim() : null;
      const displayCity = japanCityDisplay ? japanCityDisplay.value.trim() : null;
      const displayDistrict = japanTownDisplay ? japanTownDisplay.value.trim() : null;
      const hiddenProvince = deliveryCityInput ? deliveryCityInput.value.trim() : '';
      const hiddenCityFull = deliveryDistrictInput ? deliveryDistrictInput.value.trim() : '';
      const hiddenDistrict = deliveryRoadInput ? deliveryRoadInput.value.trim() : '';
      const province = displayProvince !== null ? displayProvince : hiddenProvince || current.province || '';
      let city =
        displayCity !== null
          ? displayCity
          : getJapanCityName(province, hiddenCityFull || current.cityFull || '', current.city || '');
      city = getJapanCityName(province, '', city);
      const district = displayDistrict !== null ? displayDistrict : hiddenDistrict || current.district || '';
      const cityFull = buildJapanCityFull(province, city);
      const fullAddress = buildJapanFullAddress(province, city, district);

      return normalizeJapanAddressSummary({
        ...current,
        postalCode: getCurrentJapanPostalCode() || current.postalCode,
        province,
        japanCity: city,
        cityFull,
        district,
        fullAddress,
        detail: homeDetailInput ? homeDetailInput.value.trim() : current.detail,
      });
    };

    const getAddressSummaryForMethod = (method) => {
      if (isJapanAddressMethod(method)) {
        return getSelectedMethod() === method ? getJapanAddressSummary() : state.japanAddress;
      }

      if (isHomeDeliveryMethod(method)) {
        return getSelectedMethod() === method ? getHomeSummary() : state.homeDelivery;
      }

      return null;
    };

    const syncSelectedStoreCard = (selectedMethod) => {
      if (!selectedStoreCard || !selectedStoreTitle || !selectedStoreMeta || !selectedStoreAddress) return;

      const config = getMethodConfig(selectedMethod);
      const summary = getConvenienceStoreSummary(selectedMethod);

      if (isAddressDeliveryMethod(selectedMethod) || !summary) {
        selectedStoreCard.classList.add('is-empty');
        selectedStoreTitle.textContent = config.emptyTitle || '尚未選擇門市';
        selectedStoreMeta.textContent = '';
        selectedStoreAddress.textContent = config.emptyHint || '請先選擇門市。';
        return;
      }

      selectedStoreCard.classList.remove('is-empty');
      selectedStoreTitle.textContent = summary.name || config.label;
      selectedStoreMeta.textContent = summary.code ? `門市編號 ${summary.code || '-'}` : '';
      selectedStoreAddress.textContent = summary.address;
    };

    const syncJapanAddressDisplay = (summary) => {
      const japanSummary = normalizeJapanAddressSummary(summary);
      const province = japanSummary ? japanSummary.province || '' : '';
      const city = japanSummary ? japanSummary.city || '' : '';
      const district = japanSummary ? japanSummary.district || '' : '';
      const postalCode = japanSummary ? japanSummary.postalCode || '' : '';

      if (japanProvinceDisplay && japanProvinceDisplay.value !== province) japanProvinceDisplay.value = province;
      if (japanCityDisplay && japanCityDisplay.value !== city) japanCityDisplay.value = city;
      if (japanTownDisplay && japanTownDisplay.value !== district) japanTownDisplay.value = district;
      syncJapanPostalInputs(postalCode);
    };

    const syncSelectedHomeCard = () => {
      if (!selectedHomeCard) return;

      const selectedMethod = getSelectedMethod();
      const summary = getAddressSummaryForMethod(selectedMethod);
      const config = getMethodConfig(selectedMethod);

      if (!summary || (!summary.districtFull && !summary.fullAddress)) {
        selectedHomeCard.classList.add('is-empty');
        syncJapanAddressDisplay(isJapanAddressMethod(selectedMethod) ? summary : null);
        if (selectedHomeTitle) selectedHomeTitle.textContent = config.emptyTitle || METHOD_CONFIG[HOME_DELIVERY_METHOD].emptyTitle;
        if (selectedHomeMeta) selectedHomeMeta.textContent = '';
        if (selectedHomeAddress) selectedHomeAddress.textContent = config.emptyHint || METHOD_CONFIG[HOME_DELIVERY_METHOD].emptyHint;
        return;
      }

      selectedHomeCard.classList.remove('is-empty');
      syncJapanAddressDisplay(isJapanAddressMethod(selectedMethod) ? summary : null);

      if (selectedHomeTitle) selectedHomeTitle.textContent = isJapanAddressMethod(selectedMethod) ? '日本地址' : '宅配地址';
      if (selectedHomeMeta) {
        selectedHomeMeta.textContent = isJapanAddressMethod(selectedMethod)
          ? summary.postalCode
            ? `郵編 ${summary.postalCode}`
            : ''
          : summary.districtFull && summary.road
            ? `${summary.districtFull} · ${summary.road}`
            : summary.districtFull || '';
      }
      if (selectedHomeAddress) {
        selectedHomeAddress.textContent = isJapanAddressMethod(selectedMethod)
          ? ''
          : summary.detail || '';
      }
    };

    const syncActionButtons = (selectedMethod) => {
      optionRows.forEach((row) => {
        const method = row.dataset.shippingValue;
        const button = row.querySelector('[data-shipping-trigger]');
        if (!button) return;

        button.hidden = isJapanAddressMethod(method) && state.japanAddressMode === JAPAN_ADDRESS_MODE_POSTAL;

        const config = getMethodConfig(method);
        const summary = isAddressDeliveryMethod(method) ? getAddressSummaryForMethod(method) : getConvenienceStoreSummary(method);
        const hasValue =
          isAddressDeliveryMethod(method)
            ? !!(summary && ((summary.districtFull && summary.road) || summary.fullAddress))
            : !!summary;

        button.textContent = hasValue ? config.changeLabel : config.addLabel;

        if (method === selectedMethod) {
          button.setAttribute('aria-label', hasValue ? config.changeLabel : config.addLabel);
        }
      });
    };

    const isPostalValidationMessage = (message, selectedMethod = getSelectedMethod()) =>
      !!message &&
      isJapanPostalAddressMethod(selectedMethod) &&
      (message.includes('郵編') || message.includes('郵便番号') || message.includes('7桁'));

    const syncJapanPostalMessage = (selectedMethod = getSelectedMethod()) => {
      if (!japanPostalMessage) return;

      const shouldShow = state.expanded && isPostalValidationMessage(state.validationMessage, selectedMethod);
      japanPostalMessage.textContent = shouldShow ? state.validationMessage : '';
      japanPostalMessage.hidden = !shouldShow;
    };

    const syncHint = (selectedMethod) => {
      syncJapanPostalMessage(selectedMethod);

      if (!hint) return;

      if (!state.expanded) {
        hint.textContent = '';
        hint.classList.remove('is-error');
        return;
      }

      if (state.validationMessage) {
        if (isPostalValidationMessage(state.validationMessage, selectedMethod)) {
          hint.classList.remove('is-error');
          hint.textContent = isJapanAddressMethod(selectedMethod)
            ? state.japanAddressMode === JAPAN_ADDRESS_MODE_POSTAL
              ? ''
              : ''
            : '';
          return;
        }

        hint.textContent = state.validationMessage;
        hint.classList.add('is-error');
        return;
      }

      hint.classList.remove('is-error');
      hint.textContent = isJapanAddressMethod(selectedMethod)
        ? state.japanAddressMode === JAPAN_ADDRESS_MODE_POSTAL
          ? ''
          : ''
        : isHomeDeliveryMethod(selectedMethod)
          ? '請先逐級選擇地址，再補充門牌、樓層等詳細資訊。'
          : '請先選擇門市；選定後會自動帶入門市名稱、編號與地址。';
    };
    const pickerTitle = root.querySelector('[data-store-picker-title]');
    const pickerStatus = root.querySelector('[data-store-picker-status]');
    const pickerCloseButtons = Array.from(root.querySelectorAll('[data-store-picker-close]'));
    const tabButtons = Array.from(root.querySelectorAll('[data-store-picker-tab-button]'));
    const addressView = root.querySelector('[data-store-picker-view="address"]');
    const nameView = root.querySelector('[data-store-picker-view="name"]');
    const codeView = root.querySelector('[data-store-picker-view="code"]');
    const nameInput = root.querySelector('[data-store-picker-name-input]');
    const codeInput = root.querySelector('[data-store-picker-code-input]');

    if (!detail || !radios.length || !picker || !pickerPanel) return;

    const portalOwner =
      root.closest('#main-cart-footer, .shopify-section, [id]')?.id || root.dataset.cartShippingSelector || 'main-cart-footer';

    picker.dataset.storePickerPortalOwner = portalOwner;

    const existingPortal = document.body.querySelector(
      `[data-store-picker-portal-owner="${portalOwner}"]`
    );

    if (existingPortal && existingPortal !== picker) {
      existingPortal.remove();
    }

    if (picker.parentNode !== document.body) {
      document.body.appendChild(picker);
    }

    const state = {
      expanded: detail.dataset.expanded === 'true',
      pickerOpen: false,
      activeTab: 'address',
      activeMethod: JAPAN_ADDRESS_METHOD,
      requestId: 0,
      checkoutSubmitting: false,
      addressSelection: {
        city: '',
        districtFull: '',
        road: '',
      },
      addressAccordionStep: 'city',
      data: null,
      homeDelivery: null,
      japanAddress: null,
      japanAddressMode: JAPAN_ADDRESS_MODE_ADDRESS,
      japanPostalIndex: null,
      japanPostalLookupRequestId: 0,
      japanPostalLookupLoading: false,
      japanAddressFileErrors: {},
      deliveryRoadErrors: {},
      deliverySearchRoadsLoading: false,
      storeFileErrors: {},
      storeSearchErrors: {},
      storeSearchLoading: false,
      loadError: false,
      lastTrigger: null,
      validationMessage: '',
      convenienceStoreSelections: Object.fromEntries(
        CONVENIENCE_STORE_METHODS.map((method) => [method, null])
      ),
    };



    const getContactInfo = () => ({
      name: normalizeContactName(contactNameInput ? contactNameInput.value : ''),
      phone: normalizeJapanPhone(contactPhoneInput ? contactPhoneInput.value : ''),
      email: contactEmailInput ? contactEmailInput.value.trim().toLowerCase() : '',
    });

    const syncContactCheckoutInputs = () => {
      const contact = getContactInfo();
      const nameParts = splitRecipientName(contact.name);
      if (checkoutFirstNameInput) checkoutFirstNameInput.value = nameParts.firstName;
      if (checkoutLastNameInput) checkoutLastNameInput.value = nameParts.lastName;
      return { ...contact, ...nameParts };
    };

    const saveContactInfo = () => {
      if (!contactNameInput && !contactPhoneInput && !contactEmailInput) return;
      persistShippingState({ contactInfo: getContactInfo() });
    };

    const clearContactFieldError = (fieldName) => {
      const field = root.querySelector(`[data-contact-field="${fieldName}"]`);
      const input = root.querySelector(`[data-contact-${fieldName}-input]`);
      const error = root.querySelector(`[data-contact-${fieldName}-error]`);
      if (field) field.classList.remove('is-error');
      if (input) {
        input.removeAttribute('aria-invalid');
        if (typeof input.setCustomValidity === 'function') input.setCustomValidity('');
      }
      if (error) {
        error.textContent = '';
        error.hidden = true;
      }
    };

    const clearContactErrors = () => {
      ['name', 'phone', 'email'].forEach(clearContactFieldError);
      if (contactSummaryError) {
        contactSummaryError.textContent = '';
        contactSummaryError.hidden = true;
      }
    };

    const showContactError = (fieldName, message, options = {}) => {
      const { focus = true } = options;
      const field = root.querySelector(`[data-contact-field="${fieldName}"]`);
      const input = root.querySelector(`[data-contact-${fieldName}-input]`);
      const error = root.querySelector(`[data-contact-${fieldName}-error]`);

      if (field) field.classList.add('is-error');
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        if (typeof input.setCustomValidity === 'function') input.setCustomValidity(message);
      }
      if (error) {
        error.textContent = message;
        error.hidden = false;
      }
      if (input && focus) {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => input.focus({ preventScroll: true }), 250);
      }
    };

    const validateContactInfo = () => {
      if (!contactNameInput && !contactPhoneInput && !contactEmailInput) return true;
      clearContactErrors();
      const contact = syncContactCheckoutInputs();
      const nameCharacters = contact.name.replace(/\s+/g, '');

      if (!contact.name || nameCharacters.length < 2 || /\d/.test(contact.name)) {
        showContactError('name', 'お名前を 2 文字以上でご入力ください。数字はご使用いただけません。');
        return false;
      }

      if (!contact.phone || !isValidJapanPhone(contact.phone)) {
        showContactError('phone', '有効な日本の電話番号をご入力ください。例：09012345678 / 03-1234-5678 / +819012345678');
        return false;
      }

      if (!contact.email || !isValidEmail(contact.email)) {
        showContactError('email', 'メールアドレスの形式が正しくございません。正しいアドレスをご入力ください。例：name@gmail.com');
        return false;
      }

      if (contactPhoneInput) contactPhoneInput.value = contact.phone;
      saveContactInfo();
      return true;
    };

    const getSelectedMethod = () => {
      const selectedRadio = radios.find((radio) => radio.checked);
      return selectedRadio ? selectedRadio.value : JAPAN_ADDRESS_METHOD;
    };

    const getOptionRow = (method) => optionRows.find((row) => row.dataset.shippingValue === method) || null;

    const getOptionActionButton = (method) => {
      const row = getOptionRow(method);
      return row ? row.querySelector('[data-shipping-trigger]') : null;
    };

    const normalizeJapanAddressMode = (mode) =>
      mode === JAPAN_ADDRESS_MODE_POSTAL ? JAPAN_ADDRESS_MODE_POSTAL : JAPAN_ADDRESS_MODE_ADDRESS;

    const syncJapanAddressMode = (selectedMethod = getSelectedMethod()) => {
      const isJapanMethod = isJapanAddressMethod(selectedMethod);
      if (isJapanPostalAddressMethod(selectedMethod)) {
        state.japanAddressMode = JAPAN_ADDRESS_MODE_POSTAL;
      } else if (selectedMethod === JAPAN_ADDRESS_METHOD) {
        state.japanAddressMode = JAPAN_ADDRESS_MODE_ADDRESS;
      }

      const isPostalMode = isJapanMethod && state.japanAddressMode === JAPAN_ADDRESS_MODE_POSTAL;

      if (japanPostalRow) {
        japanPostalRow.hidden = !isPostalMode;
      }

      if (japanPostalNotes) {
        japanPostalNotes.hidden = !isPostalMode;
      }

      if (japanPostalMessage && !isPostalMode) {
        japanPostalMessage.textContent = '';
        japanPostalMessage.hidden = true;
      }

      if (deliveryPostalCodeInput) {
        deliveryPostalCodeInput.disabled = !isPostalMode;
      }

      if (deliveryPostalCodeSearchButton) {
        deliveryPostalCodeSearchButton.disabled = !isPostalMode;
      }
    };

    const normalizeConvenienceStoreSummary = (method, summary) => {
      if (!CONVENIENCE_STORE_METHODS.includes(method) || !summary) return null;

      const address = String(summary.address || '').trim();

      if (!address) return null;

      return {
        chain: method,
        name: String(summary.name || '').trim(),
        code: String(summary.code || '').trim(),
        address,
        // phone: String(summary.phone || '').trim(),
        city: String(summary.city || '').trim(),
        districtFull: String(summary.districtFull || '').trim(),
        road: String(summary.road || '').trim(),
      };
    };

    const readConvenienceStoreSummaryFromInputs = () => {
      const method = storeChainInput ? storeChainInput.value.trim() : '';
      return normalizeConvenienceStoreSummary(method, {
        name: storeNameInput ? storeNameInput.value : '',
        code: storeCodeInput ? storeCodeInput.value : '',
        address: storeAddressInput ? storeAddressInput.value : '',
        // phone: storePhoneInput ? storePhoneInput.value : '',
        city: storeCityInput ? storeCityInput.value : '',
        districtFull: storeDistrictInput ? storeDistrictInput.value : '',
        road: storeRoadInput ? storeRoadInput.value : '',
      });
    };

    const writeConvenienceStoreSummaryToInputs = (summary) => {
      if (storeChainInput) storeChainInput.value = summary ? summary.chain : '';
      if (storeNameInput) storeNameInput.value = summary ? summary.name : '';
      if (storeCodeInput) storeCodeInput.value = summary ? summary.code : '';
      if (storeAddressInput) storeAddressInput.value = summary ? summary.address : '';
      // if (storePhoneInput) storePhoneInput.value = summary ? summary.phone : '';
      if (storeCityInput) storeCityInput.value = summary ? summary.city : '';
      if (storeDistrictInput) storeDistrictInput.value = summary ? summary.districtFull : '';
      if (storeRoadInput) storeRoadInput.value = summary ? summary.road : '';
    };

    const writeHomeDeliverySummaryToInputs = (summary) => {
      if (deliveryCityInput) deliveryCityInput.value = summary ? summary.city || '' : '';
      if (deliveryDistrictInput) deliveryDistrictInput.value = summary ? summary.districtFull || '' : '';
      if (deliveryRoadInput) deliveryRoadInput.value = summary ? summary.road || '' : '';
      if (deliveryPostalCodeInput) deliveryPostalCodeInput.value = '';
      if (deliveryAddressInput) deliveryAddressInput.value = summary ? summary.fullAddress || '' : '';
      if (homeDetailInput) homeDetailInput.value = summary ? summary.detail || '' : '';
      syncJapanAddressDisplay(null);
    };

    const writeJapanAddressSummaryToInputs = (summary) => {
      const japanSummary = normalizeJapanAddressSummary(summary);

      if (deliveryCityInput) deliveryCityInput.value = japanSummary ? japanSummary.province : '';
      if (deliveryDistrictInput) deliveryDistrictInput.value = japanSummary ? japanSummary.cityFull : '';
      if (deliveryRoadInput) deliveryRoadInput.value = japanSummary ? japanSummary.district : '';
      if (deliveryPostalCodeInput) deliveryPostalCodeInput.value = japanSummary ? normalizePostalCode(japanSummary.postalCode) : '';
      if (deliveryAddressInput) deliveryAddressInput.value = japanSummary ? japanSummary.fullAddress : '';
      if (homeDetailInput) homeDetailInput.value = japanSummary ? japanSummary.detail : '';
      syncJapanAddressDisplay(japanSummary);
    };

    const syncAddressInputsForMethod = (method) => {
      if (isJapanAddressMethod(method)) {
        writeJapanAddressSummaryToInputs(state.japanAddress);
        return;
      }

      if (isHomeDeliveryMethod(method)) {
        writeHomeDeliverySummaryToInputs(state.homeDelivery);
      }
    };

    const persistShippingState = (overrides = {}) => {
      const existingStoredData = loadFromLocalStorage() || {};
      const contactInfo =
        contactNameInput || contactPhoneInput || contactEmailInput
          ? getContactInfo()
          : existingStoredData.contactInfo || null;

      saveToLocalStorage({
        convenienceStoreSelections: state.convenienceStoreSelections,
        addressSelection: state.addressSelection,
        homeDelivery: state.homeDelivery,
        japanAddress: state.japanAddress,
        japanAddressMode: state.japanAddressMode,
        selectedMethod: getSelectedMethod(),
        contactInfo,
        ...overrides,
      });
    };

    const setConvenienceStoreSummary = (method, summary) => {
      if (!CONVENIENCE_STORE_METHODS.includes(method)) return;
      state.convenienceStoreSelections[method] = normalizeConvenienceStoreSummary(method, summary);
      // Save to localStorage after updating state
      persistShippingState();
    };

    const syncConvenienceStoreInputs = (method) => {
      writeConvenienceStoreSummaryToInputs(getConvenienceStoreSummary(method));
    };

    const initialConvenienceStoreSummary = readConvenienceStoreSummaryFromInputs();
    if (initialConvenienceStoreSummary) {
      setConvenienceStoreSummary(initialConvenienceStoreSummary.chain, initialConvenienceStoreSummary);
      writeConvenienceStoreSummaryToInputs(initialConvenienceStoreSummary);
    }

    // Load addresses from localStorage on initialization (sole source of truth)
    const savedAddresses = loadFromLocalStorage();

    if (savedAddresses && savedAddresses.contactInfo) {
      const contact = savedAddresses.contactInfo;
      if (contactNameInput) contactNameInput.value = contact.name || '';
      if (contactPhoneInput) contactPhoneInput.value = contact.phone || '';
      if (contactEmailInput) contactEmailInput.value = contact.email || '';
      syncContactCheckoutInputs();
    }

    if (savedAddresses) {
      let hasRestoredAddress = false;
      let restoredMethod = null;

      // Restore selected shipping method first
      if (savedAddresses.selectedMethod) {
        const methodToRestore =
          savedAddresses.selectedMethod === JAPAN_POSTAL_ADDRESS_METHOD || savedAddresses.japanAddressMode === JAPAN_ADDRESS_MODE_POSTAL
            ? JAPAN_POSTAL_ADDRESS_METHOD
            : savedAddresses.selectedMethod;
        const radioToRestore = radios.find((radio) => radio.value === methodToRestore);
        if (radioToRestore) {
          radioToRestore.checked = true;
          restoredMethod = methodToRestore;
        }
      }

      state.japanAddressMode = normalizeJapanAddressMode(
        savedAddresses.japanAddressMode ||
          (restoredMethod === JAPAN_POSTAL_ADDRESS_METHOD ? JAPAN_ADDRESS_MODE_POSTAL : JAPAN_ADDRESS_MODE_ADDRESS)
      );

      // Restore convenience store addresses
      if (savedAddresses.convenienceStoreSelections) {
        Object.keys(savedAddresses.convenienceStoreSelections).forEach((method) => {
          if (CONVENIENCE_STORE_METHODS.includes(method)) {
            const savedSummary = normalizeConvenienceStoreSummary(
              method,
              savedAddresses.convenienceStoreSelections[method]
            );
            if (savedSummary) {
              state.convenienceStoreSelections[method] = savedSummary;
              // Sync to inputs only if this is the currently selected method
              const currentMethod = getSelectedMethod();
              if (currentMethod === method) {
                writeConvenienceStoreSummaryToInputs(savedSummary);
                hasRestoredAddress = true;
              }
            }
          }
        });
      }

      // For home delivery, restore from localStorage
      if (savedAddresses.homeDelivery) {
        const homeSummary = savedAddresses.homeDelivery;
        if (homeSummary && (homeSummary.districtFull || homeSummary.road || homeSummary.fullAddress || homeSummary.detail)) {
          // Update state with complete home delivery data
          state.homeDelivery = homeSummary; // Save complete home delivery object
          // Update input fields only if home delivery is currently selected
          const currentMethod = getSelectedMethod();
          if (isHomeDeliveryMethod(currentMethod)) {
            state.addressSelection = {
              city: homeSummary.city || '',
              districtFull: homeSummary.districtFull || '',
              road: homeSummary.road || '',
            };
            writeHomeDeliverySummaryToInputs(homeSummary);
            hasRestoredAddress = true;
          }
        }
      }

      if (savedAddresses.japanAddress) {
        const japanSummary = normalizeJapanAddressSummary(savedAddresses.japanAddress);
        const savedJapanPostalCode = normalizePostalCode(savedAddresses.japanAddress.postalCode || '');
        const hasValidSavedJapanPostalCode = !savedAddresses.japanAddress.postalCode || /^\d{7}$/.test(savedJapanPostalCode);
        if (hasValidSavedJapanPostalCode && japanSummary && (japanSummary.postalCode || japanSummary.fullAddress || japanSummary.detail)) {
          state.japanAddress = japanSummary;
          const currentMethod = getSelectedMethod();
          if (isJapanAddressMethod(currentMethod)) {
            state.addressSelection = {
              city: japanSummary.province || '',
              districtFull: japanSummary.cityFull || '',
              road: japanSummary.fullAddress || '',
            };
            writeJapanAddressSummaryToInputs(japanSummary);
            hasRestoredAddress = true;
          }
        }
      }

      if (!savedAddresses.homeDelivery && savedAddresses.addressSelection) {
        // Fallback to old addressSelection format for backward compatibility
        state.addressSelection = { ...state.addressSelection, ...savedAddresses.addressSelection };
      }

      // If we restored an address, expand the detail section and update UI
      // Always expand the detail section, even if no address was restored (show empty state)
      state.expanded = true;
      if (detail) {
        detail.dataset.expanded = 'true';
        detail.removeAttribute('hidden'); // Remove hidden attribute
        detail.hidden = false;
      }
      
      // Show the appropriate field (store or home)
      const selectedMethod = getSelectedMethod();
      const isAddressDelivery = isAddressDeliveryMethod(selectedMethod);
      syncJapanAddressMode(selectedMethod);
      
      if (storeField) {
        if (isAddressDelivery) {
          storeField.setAttribute('hidden', '');
        } else {
          storeField.removeAttribute('hidden');
        }
      }
      if (homeField) {
        if (!isAddressDelivery) {
          homeField.setAttribute('hidden', '');
        } else {
          homeField.removeAttribute('hidden');
        }
      }
      
      // Disable/enable inputs based on method
      [storeChainInput, storeNameInput, storeCodeInput, storeAddressInput, storeCityInput, storeDistrictInput, storeRoadInput].forEach((input) => {
        if (input) input.disabled = isAddressDelivery;
      });
      
      [deliveryCityInput, deliveryDistrictInput, deliveryRoadInput, deliveryPostalCodeInput, deliveryAddressInput, homeDetailInput].forEach((input) => {
        if (input) input.disabled = !isAddressDelivery;
      });
      syncJapanAddressMode(selectedMethod);
      
      // Update selected card display (shows empty state or restored address)
      if (isAddressDelivery) {
        syncSelectedHomeCard();
      } else {
        syncSelectedStoreCard(selectedMethod);
      }
      
      // Update action buttons
      syncActionButtons(selectedMethod);
      
      // Update hint
      syncHint(selectedMethod);
    } else {
      // localStorage is empty, but we still need to expand the detail section to show empty state

      // Expand detail section and show empty state
      state.expanded = true;
      if (detail) {
        detail.dataset.expanded = 'true';
        detail.removeAttribute('hidden');
        detail.hidden = false;
      }
      
      // Show appropriate field based on selected method
      const selectedMethod = getSelectedMethod();
      const isAddressDelivery = isAddressDeliveryMethod(selectedMethod);
      syncJapanAddressMode(selectedMethod);
      
      if (storeField) {
        if (isAddressDelivery) {
          storeField.setAttribute('hidden', '');
        } else {
          storeField.removeAttribute('hidden');
        }
      }
      if (homeField) {
        if (!isAddressDelivery) {
          homeField.setAttribute('hidden', '');
        } else {
          homeField.removeAttribute('hidden');
        }
      }
      
      // Update UI
      if (isAddressDelivery) {
        syncSelectedHomeCard();
      } else {
        syncSelectedStoreCard(selectedMethod);
      }
      syncActionButtons(selectedMethod);
      syncHint(selectedMethod);
    }

    const setDeliveryAddressValue = () => {
      const selectedMethod = getSelectedMethod();
      const previousValue = deliveryAddressInput ? deliveryAddressInput.value.trim() : '';

      if (isJapanAddressMethod(selectedMethod)) {
        const current = state.japanAddress || {};
        const postalCode = getCurrentJapanPostalCode() || current.postalCode || '';
        const province = japanProvinceDisplay
          ? japanProvinceDisplay.value.trim()
          : deliveryCityInput
            ? deliveryCityInput.value.trim() || current.province || ''
            : current.province || '';
        let city = japanCityDisplay
          ? japanCityDisplay.value.trim()
          : getJapanCityName(province, deliveryDistrictInput ? deliveryDistrictInput.value.trim() || current.cityFull || '' : current.cityFull || '', current.city || '');
        city = getJapanCityName(province, '', city);
        const cityFull = buildJapanCityFull(province, city);
        const district = japanTownDisplay
          ? japanTownDisplay.value.trim()
          : deliveryRoadInput
            ? deliveryRoadInput.value.trim() || current.district || ''
            : current.district || '';

        const fullAddress = buildJapanFullAddress(province, city, district) || previousValue;
        const detailText = homeDetailInput ? homeDetailInput.value.trim() : current.detail || '';

        state.japanAddress = normalizeJapanAddressSummary({
          ...current,
          postalCode,
          province,
          city,
          cityFull,
          district,
          fullAddress,
          detail: detailText,
        });

        if (deliveryAddressInput) {
          deliveryAddressInput.value = fullAddress;
        }

        return fullAddress;
      }

      const parts = [];
      const districtFull = deliveryDistrictInput ? deliveryDistrictInput.value.replace(/\s+/g, '').trim() : '';
      const road = deliveryRoadInput ? deliveryRoadInput.value.trim() : '';
      const detailText = homeDetailInput ? `${homeDetailInput.value.trim()}` : '';

      if (districtFull) parts.push(districtFull);
      if (road) parts.push(road);
      if (detailText) parts.push(detailText);

      const fullAddress = parts.join('') || previousValue;

      if (deliveryAddressInput) {
        deliveryAddressInput.value = fullAddress;
      }

      state.homeDelivery = getHomeSummary();

      return fullAddress;
    };

    const buildShippingPayload = () => {
      const selectedMethod = getSelectedMethod();

      if (isHomeDeliveryMethod(selectedMethod)) {
        const summary = getHomeSummary();
        const address2 = summary ? `${summary.detail || ''}` : '';
        const city = summary ? summary.districtFull : '';
        const province = summary ? summary.city || '' : '';
        const fullAddress = summary ? `${summary.city || ''}${summary.fullAddress || ''}` : '';
        const address1 = summary ? `${city}${summary.road || ''}` : '';

        return {
          summary: fullAddress ? `${selectedMethod} - ${fullAddress}` : '',
          address1: address1 || fullAddress,
          address2,
          city,
          province,
          zip: '',
          country: fullAddress ? 'TW' : '',
        };
      }

      if (isJapanAddressMethod(selectedMethod)) {
        setDeliveryAddressValue();

        const summary = getJapanAddressSummary();
        const fullAddress = summary ? summary.fullAddress || '' : '';
        const detailText = summary ? summary.detail || '' : '';
        const address1 = summary ? `${summary.city || ''}${summary.district || ''}` : '';
        const summaryAddress = [summary && summary.postalCode, fullAddress, detailText].filter(Boolean).join(' ');

        return {
          summary: fullAddress ? `${selectedMethod} - ${summaryAddress}` : '',
          address1: address1 || fullAddress,
          address2: detailText,
          city: summary ? summary.city || '' : '',
          province: summary ? summary.province || '' : '',
          zip: summary ? summary.postalCode || '' : '',
          country: fullAddress ? 'JP' : '',
        };
      }

      const summary = getConvenienceStoreSummary(selectedMethod);
      // const company = summary && summary.name ? `${selectedMethod} ${summary.name}` : selectedMethod;
      const province = summary ? summary.city || '' : '';
      const city = summary ? summary.districtFull || '' : '';
      const addressPrefix = `${province}${city}`;
      const address1 =
        summary && summary.address
          ? summary.address.startsWith(addressPrefix)
            ? summary.address.slice(addressPrefix.length)
            : summary.address
          : '';
      const summaryParts = [];
      const address2 =
        summary && (summary.name || summary.code)
          ? `${summary.name || selectedMethod}${summary.code ? ` (${summary.code})` : ''}`
          : '';

      if (summary) {
        summaryParts.push(selectedMethod);
        if (summary.name) {
          let storeLabel = summary.name;
          if (summary.code) {
            storeLabel += ` (${summary.code})`;
          }
          summaryParts.push(storeLabel);
        }
        if (summary.address) {
          summaryParts.push(summary.address);
        }
      }

      return {
        summary: summaryParts.join(' - '),
        address1,
        address2,
        city,
        province,
        zip: '',
        country: summary && summary.address ? 'TW' : '',
      };
    };

    const syncShippingPayload = () => {
      const payload = buildShippingPayload();
      syncContactCheckoutInputs();

      if (shippingSummaryInput) shippingSummaryInput.value = payload.summary;
      if (checkoutAddress1Input) checkoutAddress1Input.value = payload.address1;
      if (checkoutCityInput) checkoutCityInput.value = payload.city;
      if (checkoutProvinceInput) checkoutProvinceInput.value = payload.province;
      if (checkoutZipInput) checkoutZipInput.value = payload.zip;
      if (checkoutCountryInput) checkoutCountryInput.value = payload.country;
    };

    // Note: We no longer persist shipping attributes to Shopify Cart Attributes
    // All shipping data is stored in localStorage instead
    const persistShippingAttributes = () => {
      // No-op: localStorage handles persistence
      return Promise.resolve();
    };

    const fetchCartSnapshot = () =>
      fetch(`${routes.cart_url}.js`, {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      }).then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load cart snapshot: ${response.status}`);
        }

        return response.json();
      });

    const buildCheckoutParams = () => {
      const payload = buildShippingPayload();
      const contact = syncContactCheckoutInputs();
      const params = new URLSearchParams();

      if (contact.email) params.set('checkout[email]', contact.email);
      if (contact.phone) params.set('checkout[shipping_address][phone]', contact.phone);
      if (contact.lastName) params.set('checkout[shipping_address][last_name]', contact.lastName);
      if (contact.firstName) params.set('checkout[shipping_address][first_name]', contact.firstName);

      // Only pass shipping address to checkout, not cart attributes
      if (payload.address1) {
        params.set('checkout[shipping_address][address1]', payload.address1);
      }
      params.set('checkout[shipping_address][address2]', payload.address2);
      if (payload.city) {
        params.set('checkout[shipping_address][city]', payload.city);
      }
      if (payload.province) {
        params.set('checkout[shipping_address][province]', payload.province);
      }
      if (payload.zip) {
        params.set('checkout[shipping_address][zip]', payload.zip);
      }
      if (payload.country) {
        params.set('checkout[shipping_address][country]', payload.country);
      }
      // Note: We no longer append cart attributes since we use localStorage
      return params;
    };

    const buildCheckoutUrl = (cart) => {
      const params = buildCheckoutParams();
      const itemsPath =
        cart && Array.isArray(cart.items)
          ? cart.items
              .filter((item) => item && item.quantity > 0 && item.id)
              .map((item) => `${item.id}:${item.quantity}`)
              .join(',')
          : '';

      const query = params.toString();
      if (!itemsPath) {
        return query ? `${routes.cart_url}?${query}` : routes.cart_url;
      }

      return query ? `${routes.cart_url}/${itemsPath}?${query}` : `${routes.cart_url}/${itemsPath}`;
    };

    const setCheckoutButtonsDisabled = (disabled) => {
      checkoutButtons.forEach((button) => {
        button.disabled = disabled;
        if (disabled) {
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-disabled');
        }
      });
    };

    const beginCheckout = (event) => {
      // Button disabled state and dedup timestamp share the same 5s window
      const now = Date.now();
      if (state.checkoutSubmitting && (now - state.checkoutSubmitting) < 5000) {
        if (event) event.preventDefault();
        return;
      }

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (!validateBeforeCheckout()) {
        updateState();
        return;
      }

      setDeliveryAddressValue();
      syncShippingPayload();
      state.checkoutSubmitting = now;
      setCheckoutButtonsDisabled(true);

      Promise.allSettled([persistShippingAttributes(), fetchCartSnapshot()])
        .then((results) => {
          const cartResult = results[1];
          if (cartResult.status === 'fulfilled') {
            return buildCheckoutUrl(cartResult.value);
          }

          console.error('Cart snapshot load failed:', cartResult.reason);
          return buildCheckoutUrl(null);
        })
        .catch((error) => {
          console.error('Checkout redirect build failed:', error);
          return buildCheckoutUrl(null);
        })
        .then((checkoutUrl) => {
          window.location.assign(checkoutUrl);
        });
    };

    const setHidden = (element, isHidden) => {
      if (!element) return;
      element.hidden = isHidden;

      if (isHidden) {
        element.setAttribute('hidden', 'hidden');
      } else {
        element.removeAttribute('hidden');
      }
    };

    const syncPickerTabs = (selectedMethod) => {
      tabButtons.forEach((button) => {
        const tab = button.dataset.storePickerTabButton;
        // Address methods do not have store codes, but keep keyword search available.
        button.hidden = isAddressDeliveryMethod(selectedMethod) && tab === 'code';
      });

      if (isAddressDeliveryMethod(selectedMethod) && state.activeTab === 'code') {
        state.activeTab = 'address';
      }
    };

    const setActiveTab = (tab) => {
      state.activeTab = tab;

      tabButtons.forEach((button) => {
        const isActive = button.dataset.storePickerTabButton === tab;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      [addressView, nameView, codeView].forEach((view) => {
        if (!view) return;
        view.hidden = view.dataset.storePickerView !== tab;
      });

      renderActiveView();
    };

    const clearValidationState = () => {
      state.validationMessage = '';

      optionRows.forEach((row) => row.classList.remove('is-error'));
      triggerButtons.forEach((button) => button.classList.remove('is-error'));

      if (selectedStoreCard) selectedStoreCard.classList.remove('is-error');
      if (selectedHomeCard) selectedHomeCard.classList.remove('is-error');
      if (deliveryPostalCodeInput) deliveryPostalCodeInput.classList.remove('is-error');
      if (japanPostalDisplay) japanPostalDisplay.classList.remove('is-error');
      if (japanPostalMessage) {
        japanPostalMessage.textContent = '';
        japanPostalMessage.hidden = true;
      }
      if (homeDetailInput) homeDetailInput.classList.remove('is-error');
      if (hint) hint.classList.remove('is-error');
    };

    const showValidationError = (message, invalidMethod, options = {}) => {
      const { requireStore = false, requireHomeAddress = false, requireHomeDetail = false, requirePostalCode = false } = options;

      state.validationMessage = message;
      state.expanded = true;

      const row = getOptionRow(invalidMethod);
      const actionButton = getOptionActionButton(invalidMethod);

      if (row) row.classList.add('is-error');
      if (actionButton) actionButton.classList.add('is-error');
      if (hint) hint.classList.add('is-error');
      if (requireStore && selectedStoreCard) selectedStoreCard.classList.add('is-error');
      if (requireHomeAddress && selectedHomeCard) selectedHomeCard.classList.add('is-error');
      if ((requireHomeAddress || requirePostalCode) && deliveryPostalCodeInput) deliveryPostalCodeInput.classList.add('is-error');
      if (requirePostalCode && japanPostalDisplay) japanPostalDisplay.classList.add('is-error');
      if (requireHomeDetail && homeDetailInput) homeDetailInput.classList.add('is-error');
    };

    const validateShippingBeforeCheckout = () => {
      clearValidationState();

      const selectedMethod = getSelectedMethod();

      if (isHomeDeliveryMethod(selectedMethod)) {
        setDeliveryAddressValue();

        const homeSummary = getHomeSummary();
        const hasAddressSelection = !!(homeSummary && homeSummary.districtFull && homeSummary.road && homeSummary.fullAddress);
        const hasDetail = !!(homeDetailInput && homeDetailInput.value.trim());

        if (!hasAddressSelection) {
          showValidationError('請先完成宅配地址選擇。', selectedMethod, { requireHomeAddress: true });
          return false;
        }

        if (!hasDetail) {
          showValidationError('請填寫宅配詳細地址，例如門牌、樓層、房號。', selectedMethod, {
            requireHomeDetail: true,
          });
          return false;
        }

        return true;
      }

      if (isJapanAddressMethod(selectedMethod)) {
        setDeliveryAddressValue();

        const japanSummary = getJapanAddressSummary();
        const hasPostalCode = !!(japanSummary && /^\d{7}$/.test(japanSummary.postalCode || ''));
        const hasAddressSelection = !!(
          japanSummary &&
          japanSummary.province &&
          japanSummary.city &&
          japanSummary.district &&
          japanSummary.fullAddress
        );
        const hasDetail = !!(homeDetailInput && homeDetailInput.value.trim());

        if (!hasAddressSelection) {
          showValidationError('先に日本国内の住所を選択してください。', selectedMethod, { requireHomeAddress: true });
          return false;
        }

        if (!hasPostalCode) {
          showValidationError('7 桁の郵便番号をご入力ください。', selectedMethod, { requirePostalCode: true });
          return false;
        }

        if (!hasDetail) {
          showValidationError('日本国内の詳細な住所をご記入ください。番地、建物名、部屋番号まで漏れなくご入力ください。', selectedMethod, {
            requireHomeDetail: true,
          });
          return false;
        }

        return true;
      }

      const storeSummary = getConvenienceStoreSummary(selectedMethod);

      if (!storeSummary) {
        showValidationError(`請先選擇${selectedMethod}門市。`, selectedMethod, { requireStore: true });
        return false;
      }

      return true;
    };


    const validateBeforeCheckout = () => {
      if (!validateShippingBeforeCheckout()) return false;
      return validateContactInfo();
    };

    const updateState = () => {
      const selectedMethod = getSelectedMethod();
      const isAddressDelivery = isAddressDeliveryMethod(selectedMethod);
      syncJapanAddressMode(selectedMethod);

      if (isAddressDelivery) {
        setDeliveryAddressValue();
        writeConvenienceStoreSummaryToInputs(null);
      } else {
        syncConvenienceStoreInputs(selectedMethod);
      }

      optionRows.forEach((row) => {
        row.classList.toggle('is-selected', row.dataset.shippingValue === selectedMethod);
      });

      setHidden(detail, !state.expanded);
      detail.dataset.expanded = state.expanded ? 'true' : 'false';

      setHidden(storeField, !state.expanded || isAddressDelivery);

      setHidden(homeField, !state.expanded || !isAddressDelivery);

      [storeChainInput, storeNameInput, storeCodeInput, storeAddressInput, storeCityInput, storeDistrictInput, storeRoadInput].forEach((input) => {
        if (input) input.disabled = isAddressDelivery;
      });

      [deliveryCityInput, deliveryDistrictInput, deliveryRoadInput, deliveryPostalCodeInput, deliveryAddressInput, homeDetailInput].forEach((input) => {
        if (input) input.disabled = !isAddressDelivery;
      });
      syncJapanAddressMode(selectedMethod);

      syncShippingPayload();
      syncPickerTabs(selectedMethod);
      syncSelectedStoreCard(selectedMethod);
      syncSelectedHomeCard();
      syncHint(selectedMethod);
      syncActionButtons(selectedMethod);
    };

    const closePicker = () => {
      state.pickerOpen = false;
      state.requestId += 1;
      picker.classList.remove('is-open');
      picker.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      if (state.lastTrigger && document.contains(state.lastTrigger)) {
        state.lastTrigger.focus();
      }
    };

    const selectStore = (store) => {
      const method = state.activeMethod;

      setConvenienceStoreSummary(method, {
        name: store[STORE_INDEX.name] || '',
        code: store[STORE_INDEX.id] || '',
        address: store[STORE_INDEX.address] || '',
        // phone: store[STORE_INDEX.phone] || '',
        city: store[STORE_INDEX.city] || '',
        districtFull: store[STORE_INDEX.districtFull] || '',
        road: store[STORE_INDEX.road] || '',
      });
      syncConvenienceStoreInputs(method);

      clearValidationState();
      state.expanded = true;
      updateState();
      closePicker();
    };

    const selectHomeRoad = (road) => {
      if (deliveryCityInput) deliveryCityInput.value = state.addressSelection.city || '';
      if (deliveryDistrictInput) deliveryDistrictInput.value = state.addressSelection.districtFull || '';
      if (deliveryRoadInput) deliveryRoadInput.value = road || '';

      state.addressSelection.road = road || '';
      // Save complete home delivery address to localStorage
      setDeliveryAddressValue();
      const homeSummary = getHomeSummary();
      state.homeDelivery = homeSummary;
      persistShippingState();
      clearValidationState();
      state.expanded = true;
      updateState();
      closePicker();

      if (homeDetailInput) {
        homeDetailInput.focus();
      }
    };

    const getChainData = () => {
      if (!state.data) return null;
      const config = getMethodConfig(state.activeMethod);
      return state.data.chains ? state.data.chains[config.chainKey] : null;
    };

    const getActiveAddressData = () => {
      if (!state.data) return null;
      if (isJapanAddressMethod(state.activeMethod)) return state.data.japan || null;
      if (isHomeDeliveryMethod(state.activeMethod)) return state.data.delivery || null;
      return getChainData();
    };

    const loadDeliveryRoadsForCity = (city) => {
      const delivery = state.data && state.data.delivery;

      if (!delivery || !city || hasDeliveryRoadsForCity(delivery, city)) {
        return Promise.resolve(delivery);
      }

      const fileName = delivery.roadFilesByCity ? delivery.roadFilesByCity[city] : '';
      if (!fileName) return Promise.resolve(delivery);

      state.deliveryRoadErrors[city] = false;

      return loadStoreData(buildStorePickerAssetUrl(picker, fileName))
        .then((data) => {
          delivery.roadsByDistrict = {
            ...(delivery.roadsByDistrict || {}),
            ...(data.roadsByDistrict || data),
          };
          state.deliveryRoadErrors[city] = false;
          return delivery;
        })
        .catch((error) => {
          state.deliveryRoadErrors[city] = true;
          throw error;
        });
    };

    const loadAllDeliveryRoads = () => {
      const delivery = state.data && state.data.delivery;

      if (!delivery || hasAllDeliveryRoads(delivery)) return Promise.resolve(delivery);

      const cities = (delivery.cities || []).filter((city) => !hasDeliveryRoadsForCity(delivery, city) && !state.deliveryRoadErrors[city]);

      if (!cities.length) return Promise.reject(new Error('Failed to load delivery roads'));

      return Promise.allSettled(cities.map((city) => loadDeliveryRoadsForCity(city))).then((results) => {
        const failed = results.some((result) => result.status === 'rejected');
        if (failed) throw new Error('Failed to load delivery roads');
        return delivery;
      });
    };

    const hasJapanAddressesForProvince = (japan, province) =>
      Boolean(japan && province && japan.addressesByProvince && Array.isArray(japan.addressesByProvince[province]));

    const loadJapanAddressesForProvince = (province) => {
      const japan = state.data && state.data.japan;

      if (!japan || !province || hasJapanAddressesForProvince(japan, province)) {
        return Promise.resolve(japan);
      }

      const fileName = japan.addressFilesByProvince ? japan.addressFilesByProvince[province] : '';
      if (!fileName) return Promise.resolve(japan);

      state.japanAddressFileErrors[province] = false;

      return loadStoreData(buildStorePickerAssetUrl(picker, fileName))
        .then((data) => {
          japan.citiesByProvince = {
            ...(japan.citiesByProvince || {}),
            [province]: data.cities || (japan.citiesByProvince && japan.citiesByProvince[province]) || [],
          };
          japan.districtsByCity = {
            ...(japan.districtsByCity || {}),
            ...(data.districtsByCity || {}),
          };
          japan.addressesByProvince = {
            ...(japan.addressesByProvince || {}),
            [province]: data.addresses || [],
          };
          state.japanAddressFileErrors[province] = false;
          return japan;
        })
        .catch((error) => {
          state.japanAddressFileErrors[province] = true;
          throw error;
        });
    };

    const loadJapanDataForPostalLookup = () => {
      if (state.data && state.data.japan) {
        return Promise.resolve(state.data.japan);
      }

      return loadMethodData(picker, JAPAN_ADDRESS_METHOD).then((data) => {
        state.data = data;
        state.loadError = false;
        return data.japan;
      });
    };

    const loadJapanPostalIndexForPicker = () => {
      if (state.japanPostalIndex) {
        return Promise.resolve(state.japanPostalIndex);
      }

      return loadJapanPostalIndex(picker).then((index) => {
        state.japanPostalIndex = index || null;
        return state.japanPostalIndex;
      });
    };

    const getJapanPostalCandidateProvinces = (japan, postalIndex, postalCode) => {
      const prefix = postalCode.slice(0, 3);
      const knownProvinces = new Set(japan.provinces || Object.keys(japan.addressFilesByProvince || {}));

      if (postalIndex && postalIndex.prefixes) {
        return (postalIndex.prefixes[prefix] || []).filter((province) => knownProvinces.has(province));
      }

      return Array.from(knownProvinces);
    };

    const findJapanAddressesByPostalCode = (postalCode) => {
      const normalizedPostalCode = normalizePostalCode(postalCode);

      if (!/^\d{7}$/.test(normalizedPostalCode)) {
        return Promise.resolve([]);
      }

      return Promise.all([loadJapanDataForPostalLookup(), loadJapanPostalIndexForPicker().catch(() => null)]).then(([japan, postalIndex]) => {
        if (!japan) return [];

        const candidateProvinces = getJapanPostalCandidateProvinces(japan, postalIndex, normalizedPostalCode);
        if (!candidateProvinces.length) return [];

        return Promise.allSettled(candidateProvinces.map((province) => loadJapanAddressesForProvince(province))).then(() => {
          const matches = [];

          candidateProvinces.forEach((province) => {
            const addresses = japan.addressesByProvince ? japan.addressesByProvince[province] || [] : [];

            addresses.forEach((address) => {
              if (normalizePostalCode(address[JAPAN_ADDRESS_INDEX.postalCode]) === normalizedPostalCode) {
                matches.push(address);
              }
            });
          });

          return matches;
        });
      });
    };

    const getStoreCacheKey = (method, city) => `${method}|${city}`;

    const hasStoresForCity = (chainData, city) => {
      if (!chainData || !city) return false;
      if (Array.isArray(chainData.stores)) return true;
      return Boolean(chainData.storesByCity && chainData.storesByCity[city]);
    };

    const mergeStoreFileData = (chainData, data) => {
      if (!chainData) return [];

      const city = data && data.city;
      const stores = data && (data.stores || data);

      if (!city || !Array.isArray(stores)) return [];

      chainData.storesByCity = {
        ...(chainData.storesByCity || {}),
        [city]: stores,
      };

      return stores;
    };

    const loadStoresForCity = (city) => {
      const chainData = getChainData();

      if (!chainData || !city || hasStoresForCity(chainData, city)) {
        return Promise.resolve(chainData);
      }

      const fileName = chainData.storeFilesByCity ? chainData.storeFilesByCity[city] : '';
      if (!fileName) return Promise.resolve(chainData);

      const cacheKey = getStoreCacheKey(state.activeMethod, city);
      state.storeFileErrors[cacheKey] = false;

      return loadStoreData(buildStorePickerAssetUrl(picker, fileName))
        .then((data) => {
          mergeStoreFileData(chainData, data);
          state.storeFileErrors[cacheKey] = false;
          return chainData;
        })
        .catch((error) => {
          state.storeFileErrors[cacheKey] = true;
          throw error;
        });
    };

    const loadStoreSearchIndex = () => {
      const chainData = getChainData();

      if (!chainData || Array.isArray(chainData.stores) || Array.isArray(chainData.searchStores)) {
        return Promise.resolve(chainData);
      }

      const fileName = chainData.searchFile;
      if (!fileName) return Promise.resolve(chainData);

      const cacheKey = `${state.activeMethod}|search`;
      state.storeSearchErrors[cacheKey] = false;

      return loadStoreData(buildStorePickerAssetUrl(picker, fileName))
        .then((data) => {
          chainData.searchFiles = data.files || [];
          chainData.searchStores = data.stores || data;
          state.storeSearchErrors[cacheKey] = false;
          return chainData;
        })
        .catch((error) => {
          state.storeSearchErrors[cacheKey] = true;
          throw error;
        });
    };

    const findStoreInChainData = (chainData, code, address) => {
      const matchesStore = (store) => store && (store[STORE_INDEX.id] === code || store[STORE_INDEX.address] === address);

      if (Array.isArray(chainData.stores)) {
        return chainData.stores.find(matchesStore) || null;
      }

      if (!chainData.storesByCity) return null;

      for (const stores of Object.values(chainData.storesByCity)) {
        const found = stores.find(matchesStore);
        if (found) return found;
      }

      return null;
    };

    const getStoreSearchEntryFileName = (chainData, entry) => {
      const fileReference = entry[STORE_SEARCH_INDEX.fileName];

      if (typeof fileReference === 'number') {
        return (chainData.searchFiles && chainData.searchFiles[fileReference]) || '';
      }

      return fileReference || '';
    };

    const loadStoreForSearchEntry = (entry) => {
      const chainData = getChainData();
      if (!chainData) return Promise.resolve(null);

      const code = entry[STORE_SEARCH_INDEX.id] || '';
      const address = entry[STORE_SEARCH_INDEX.address] || '';
      const existingStore = findStoreInChainData(chainData, code, address);

      if (existingStore) return Promise.resolve(existingStore);

      const fileName = getStoreSearchEntryFileName(chainData, entry);
      if (!fileName) return Promise.resolve(null);

      return loadStoreData(buildStorePickerAssetUrl(picker, fileName)).then((data) => {
        mergeStoreFileData(chainData, data);
        return findStoreInChainData(chainData, code, address);
      });
    };

    const getStoresForSelectedRoad = (chainData) => {
      if (!chainData || !state.addressSelection.districtFull) return [];

      const stores = Array.isArray(chainData.stores)
        ? chainData.stores
        : (chainData.storesByCity && chainData.storesByCity[state.addressSelection.city]) || [];

      return stores.filter((store) => {
        if (store[STORE_INDEX.districtFull] !== state.addressSelection.districtFull) return false;
        if (state.addressSelection.road) {
          return store[STORE_INDEX.road] === state.addressSelection.road;
        }

      return true;
      });
    };

    const findJapanAddress = (province, cityFull, districtFull) => {
      const japan = state.data && state.data.japan;
      const addresses = japan && japan.addressesByProvince ? japan.addressesByProvince[province] || [] : [];

      return (
        addresses.find((address) => {
          const fullAddress = `${address[JAPAN_ADDRESS_INDEX.province] || ''}${address[JAPAN_ADDRESS_INDEX.city] || ''}${address[JAPAN_ADDRESS_INDEX.district] || ''}`;
          const addressCityFull = `${address[JAPAN_ADDRESS_INDEX.province] || ''}${address[JAPAN_ADDRESS_INDEX.city] || ''}`;
          return fullAddress === districtFull && addressCityFull === cityFull;
        }) || null
      );
    };

    const clearJapanAddressSelection = (postalCode = '') => {
      const detailText = homeDetailInput ? homeDetailInput.value.trim() : '';
      const normalizedPostalCode = normalizePostalCode(postalCode);

      state.addressSelection = {
        city: '',
        districtFull: '',
        road: '',
      };

      state.japanAddress =
        normalizedPostalCode || detailText
          ? normalizeJapanAddressSummary({
              postalCode: normalizedPostalCode,
              detail: detailText,
            })
          : null;

      writeJapanAddressSummaryToInputs(state.japanAddress);

      if (deliveryAddressInput) {
        deliveryAddressInput.value = '';
      }
    };

    const selectJapanAddress = (address, options = {}) => {
      if (!address) return;

      const { closeAfterSelect = true, focusDetail = true } = options;
      const postalCode = address[JAPAN_ADDRESS_INDEX.postalCode] || '';
      const province = address[JAPAN_ADDRESS_INDEX.province] || '';
      const city = address[JAPAN_ADDRESS_INDEX.city] || '';
      const district = address[JAPAN_ADDRESS_INDEX.district] || '';
      const cityFull = `${province}${city}`;
      const fullAddress = `${cityFull}${district}`;
      const detailText = homeDetailInput ? homeDetailInput.value.trim() : '';

      state.addressSelection = {
        city: province,
        districtFull: cityFull,
        road: fullAddress,
      };

      state.japanAddress = normalizeJapanAddressSummary({
        postalCode,
        province,
        city,
        cityFull,
        district,
        fullAddress,
        detail: detailText,
      });

      writeJapanAddressSummaryToInputs(state.japanAddress);
      persistShippingState();
      clearValidationState();
      state.expanded = true;
      updateState();
      if (closeAfterSelect && state.pickerOpen) {
        closePicker();
      }

      if (focusDetail && homeDetailInput) {
        homeDetailInput.focus();
      }
    };

    const normalizeJapanPostalCodeInput = () => {
      if (!deliveryPostalCodeInput || !isJapanPostalAddressMethod(getSelectedMethod())) return;

      const postalCode = syncJapanPostalInputs(deliveryPostalCodeInput.value, deliveryPostalCodeInput);

      clearValidationState();
      const currentPostalCode = state.japanAddress ? normalizePostalCode(state.japanAddress.postalCode) : '';

      if (postalCode !== currentPostalCode) {
        state.japanPostalLookupLoading = false;
        clearJapanAddressSelection(postalCode);
        updateState();
        persistShippingState();
      }

      if (postalCode.length < 7) {
        state.japanPostalLookupLoading = false;
        return;
      }
    };

    const handleJapanPostalCodeSearch = () => {
      if (!deliveryPostalCodeInput || !isJapanPostalAddressMethod(getSelectedMethod())) return;

      normalizeJapanPostalCodeInput();

      const postalCode = normalizePostalCode(deliveryPostalCodeInput.value);
      const currentPostalCode = state.japanAddress ? normalizePostalCode(state.japanAddress.postalCode) : '';

      if (postalCode.length < 7) {
        state.japanPostalLookupLoading = false;
        state.validationMessage = '7桁の郵便番号を入力してください。';
        updateState();
        persistShippingState();
        return;
      }

      if (state.japanAddress && currentPostalCode === postalCode && state.japanAddress.fullAddress) {
        state.japanPostalLookupLoading = false;
        updateState();
        persistShippingState();
        return;
      }

      state.japanPostalLookupRequestId += 1;
      const requestId = state.japanPostalLookupRequestId;

      clearJapanAddressSelection(postalCode);
      state.japanPostalLookupLoading = true;
      updateState();

      findJapanAddressesByPostalCode(postalCode)
        .then((matches) => {
          if (requestId !== state.japanPostalLookupRequestId || normalizePostalCode(deliveryPostalCodeInput.value) !== postalCode) return;

          state.japanPostalLookupLoading = false;

          if (!matches.length) {
            clearJapanAddressSelection(postalCode);
            state.validationMessage = 'この郵便番号は見つかりません。ご確認の上、再度ご入力ください。';
            updateState();
            persistShippingState();
            return;
          }

          selectJapanAddress(matches[0], {
            closeAfterSelect: false,
            focusDetail: true,
          });
        })
        .catch((error) => {
          if (requestId !== state.japanPostalLookupRequestId || normalizePostalCode(deliveryPostalCodeInput.value) !== postalCode) return;

          console.warn('Failed to look up Japan address by postal code:', error);
          state.japanPostalLookupLoading = false;
          clearJapanAddressSelection(postalCode);
          state.validationMessage = '郵便番号データ読み込み失敗。時間をおいて再試行してください。';
          updateState();
          persistShippingState();
        });
    };

    const validateSavedSelections = (data) => {
      if (!data) return;
      let changed = false;

      // Validate the active convenience store selection only; data is now loaded per method.
      if (CONVENIENCE_STORE_METHODS.includes(state.activeMethod)) {
        const method = state.activeMethod;
        const saved = state.convenienceStoreSelections[method];
        if (!saved) return;

        const config = METHOD_CONFIG[method];
        const chainData = data.chains ? data.chains[config.chainKey] : null;

        if (!chainData) {
          state.convenienceStoreSelections[method] = null;
          changed = true;
          return;
        }

        const cityKnown = saved.city ? (chainData.cities || []).includes(saved.city) : true;
        const storesLoaded = saved.city ? hasStoresForCity(chainData, saved.city) : Boolean(chainData.stores);
        const stillExists = storesLoaded ? Boolean(findStoreInChainData(chainData, saved.code, saved.address)) : cityKnown;

        if (!stillExists) {
          state.convenienceStoreSelections[method] = null;
          changed = true;
        }
      }

      // Validate home delivery address
      if (state.homeDelivery && data.delivery) {
        const delivery = data.delivery;
        const hd = state.homeDelivery;
        const cityValid = hd.city && delivery.cities.includes(hd.city);
        const districts = cityValid ? (delivery.districtsByCity[hd.city] || []) : [];
        const districtValid = hd.districtFull && districts.some(([, full]) => full === hd.districtFull);
        const roadsLoaded = cityValid ? hasDeliveryRoadsForCity(delivery, hd.city) : false;
        const roads = districtValid && roadsLoaded ? (delivery.roadsByDistrict[hd.districtFull] || []) : [];
        const roadValid = hd.road ? !roadsLoaded || roads.includes(hd.road) : true;

        if (!cityValid || !districtValid || !roadValid) {
          state.homeDelivery = null;
          state.addressSelection = { city: '', districtFull: '', road: '' };
          changed = true;
        }
      }

      if (state.japanAddress && data.japan) {
        const japan = data.japan;
        const jp = normalizeJapanAddressSummary(state.japanAddress);
        const provinceValid = jp && jp.province && (japan.provinces || []).includes(jp.province);
        const cities = provinceValid ? (japan.citiesByProvince && japan.citiesByProvince[jp.province]) || [] : [];
        const cityValid = jp && jp.cityFull && cities.some(([, cityFull]) => cityFull === jp.cityFull);
        let addressValid = Boolean(provinceValid && cityValid);

        if (addressValid && hasJapanAddressesForProvince(japan, jp.province)) {
          const addresses = japan.addressesByProvince[jp.province] || [];
          addressValid = addresses.some((address) => {
            const fullAddress = `${address[JAPAN_ADDRESS_INDEX.province] || ''}${address[JAPAN_ADDRESS_INDEX.city] || ''}${address[JAPAN_ADDRESS_INDEX.district] || ''}`;
            return (
              address[JAPAN_ADDRESS_INDEX.postalCode] === jp.postalCode &&
              address[JAPAN_ADDRESS_INDEX.province] === jp.province &&
              address[JAPAN_ADDRESS_INDEX.city] === jp.city &&
              fullAddress === jp.fullAddress
            );
          });
        }

        if (!addressValid) {
          state.japanAddress = null;
          if (isJapanAddressMethod(state.activeMethod)) {
            state.addressSelection = { city: '', districtFull: '', road: '' };
            writeJapanAddressSummaryToInputs(null);
          }
          changed = true;
        }
      }

      if (changed) {
        persistShippingState();

        // Sync inputs for current method
        const currentMethod = getSelectedMethod();
        if (isAddressDeliveryMethod(currentMethod)) {
          syncSelectedHomeCard();
        } else {
          syncConvenienceStoreInputs(currentMethod);
          syncSelectedStoreCard(currentMethod);
        }
        syncActionButtons(currentMethod);
      }
    };

    const toggleAddressAccordionStep = (step) => {
      state.addressAccordionStep = state.addressAccordionStep === step ? null : step;
      renderAddressView();
    };

    const getDefaultAddressAccordionStep = () => {
      if (!state.addressSelection.city) return 'city';
      if (!state.addressSelection.districtFull) return 'district';
      if (!state.addressSelection.road) return 'road';
      if (isAddressDeliveryMethod(state.activeMethod)) return 'road';
      return 'store';
    };

    let renderAddressView = () => {
      if (!addressView) return;
      clearChildren(addressView);

      if (!state.data) {
        addressView.appendChild(buildEmptyMessage(state.loadError ? '住所情報の読み込み失敗。時間を置いて再読み込みをお願いします。' : '住所データを読み込んでいます...'));
        return;
      }

      const addressData = getActiveAddressData();

      if (!addressData) {
        addressView.appendChild(buildEmptyMessage('住所情報の読み込み失敗。時間を置いて再読み込みをお願いします。'));
        return;
      }

      const cityStep = buildStep('請選擇縣市', { columns: 4 });
      const districtStep = buildStep('請選擇鄉、鎮、市、區', { columns: 3 });
      const roadStep = buildStep('請選擇街道', { columns: 2 });

      addressData.cities.forEach((city) => {
        cityStep.body.appendChild(
          buildChoiceButton(city, state.addressSelection.city === city, () => {
            state.addressSelection.city = city;
            state.addressSelection.districtFull = '';
            state.addressSelection.road = '';
            renderAddressView();
          })
        );
      });

      if (!addressData.cities.length) {
        cityStep.body.appendChild(buildEmptyMessage('目前沒有可選縣市。'));
      }

      const districts = state.addressSelection.city ? addressData.districtsByCity[state.addressSelection.city] || [] : [];

      if (districts.length) {
        districts.forEach(([district, districtFull]) => {
          districtStep.body.appendChild(
            buildChoiceButton(district, state.addressSelection.districtFull === districtFull, () => {
              state.addressSelection.districtFull = districtFull;
              state.addressSelection.road = '';
              renderAddressView();
            })
          );
        });
      } else {
        districtStep.body.appendChild(buildEmptyMessage('請先選擇縣市。'));
      }

      const roads = state.addressSelection.districtFull ? addressData.roadsByDistrict[state.addressSelection.districtFull] || [] : [];

      if (roads.length) {
        roads.forEach((road) => {
          roadStep.body.appendChild(
            buildChoiceButton(road, state.addressSelection.road === road, () => {
              if (isHomeDeliveryMethod(state.activeMethod)) {
                selectHomeRoad(road);
              } else {
                state.addressSelection.road = road;
                renderAddressView();
              }
            })
          );
        });
      } else if (state.addressSelection.districtFull) {
        roadStep.body.appendChild(buildEmptyMessage('此區域沒有可用街道資料。'));
      } else {
        roadStep.body.appendChild(buildEmptyMessage('請先選擇鄉、鎮、市、區。'));
      }

      addressView.appendChild(cityStep.step);
      addressView.appendChild(districtStep.step);
      addressView.appendChild(roadStep.step);

      if (isHomeDeliveryMethod(state.activeMethod)) {
        return;
      }

      const storeStep = buildStep('請選擇門市', { columns: 1 });
      const stores = getStoresForSelectedRoad(addressData);

      if (stores.length) {
        stores.forEach((store) => {
          storeStep.body.appendChild(buildStoreButton(store, selectStore));
        });
      } else if (state.addressSelection.districtFull) {
        storeStep.body.appendChild(buildEmptyMessage('此篩選條件下沒有門市。'));
      } else {
        storeStep.body.appendChild(buildEmptyMessage('請先完成上方地址選擇。'));
      }

      addressView.appendChild(storeStep.step);
    };

    const renderJapanAddressView = (addressData) => {
      const province = state.addressSelection.city;
      const cityFull = state.addressSelection.districtFull;
      const provinceFileError = province && state.japanAddressFileErrors[province];
      const provinceAddressesLoaded = hasJapanAddressesForProvince(addressData, province);
      const shouldLoadProvinceAddresses = province && !provinceAddressesLoaded && !provinceFileError;

      if (shouldLoadProvinceAddresses) {
        loadJapanAddressesForProvince(province)
          .then(() => {
            if (state.pickerOpen && isJapanAddressMethod(state.activeMethod)) renderAddressView();
          })
          .catch(() => {
            if (state.pickerOpen && isJapanAddressMethod(state.activeMethod)) renderAddressView();
          });
      }

      const cityStep = buildStep('都道府県選択', {
        isExpanded: state.addressAccordionStep === 'city',
        summary: province,
        onToggle: () => toggleAddressAccordionStep('city'),
        columns: 4,
      });
      const districtStep = buildStep('市区町村選択', {
        isExpanded: state.addressAccordionStep === 'district',
        summary: cityFull,
        onToggle: () => toggleAddressAccordionStep('district'),
        columns: 3,
      });
      const roadStep = buildStep('町域をご選択', {
        isExpanded: state.addressAccordionStep === 'road',
        summary: state.japanAddress && state.japanAddress.postalCode ? `${state.japanAddress.postalCode} ${state.addressSelection.road}` : state.addressSelection.road,
        onToggle: () => toggleAddressAccordionStep('road'),
        columns: 2,
      });

      (addressData.provinces || []).forEach((provinceName) => {
        cityStep.body.appendChild(
          buildChoiceButton(provinceName, province === provinceName, () => {
            state.addressSelection.city = provinceName;
            state.addressSelection.districtFull = '';
            state.addressSelection.road = '';
            state.japanAddressFileErrors[provinceName] = false;
            state.addressAccordionStep = 'district';
            renderAddressView();
          })
        );
      });

      if (!(addressData.provinces || []).length) {
        cityStep.body.appendChild(buildEmptyMessage('選択可能な都道府県なし'));
      }

      const cities = province ? (addressData.citiesByProvince && addressData.citiesByProvince[province]) || [] : [];

      if (cities.length) {
        cities.forEach(([cityName, cityNameFull]) => {
          districtStep.body.appendChild(
            buildChoiceButton(cityName, cityFull === cityNameFull, () => {
              state.addressSelection.districtFull = cityNameFull;
              state.addressSelection.road = '';
              state.addressAccordionStep = 'road';
              renderAddressView();
            })
          );
        });
      } else if (province) {
        districtStep.body.appendChild(buildEmptyMessage('こちらの都道府県には選択可能な市区町村の情報がございません。'));
      } else {
        districtStep.body.appendChild(buildEmptyMessage('先に都道府県を選択。'));
      }

      const districts = cityFull ? (addressData.districtsByCity && addressData.districtsByCity[cityFull]) || [] : [];
      const selectableDistricts = districts.filter(([districtName]) => districtName !== JAPAN_UNLISTED_DISTRICT_LABEL);

      if (selectableDistricts.length) {
        selectableDistricts.forEach(([districtName, districtFull]) => {
          roadStep.body.appendChild(
            buildChoiceButton(districtName, state.addressSelection.road === districtFull, () => {
              const address = findJapanAddress(province, cityFull, districtFull);
              if (address) selectJapanAddress(address);
            })
          );
        });
      } else if (shouldLoadProvinceAddresses) {
        roadStep.body.appendChild(buildEmptyMessage('町域データ読み込み中…'));
      } else if (provinceFileError) {
        roadStep.body.appendChild(buildEmptyMessage('町域データ読み込みエラー。後ほど再試行してください。'));
      } else if (cityFull) {
        roadStep.body.appendChild(buildEmptyMessage('当該市区町村に町域データがありません。'));
      } else {
        roadStep.body.appendChild(buildEmptyMessage('先に市区町村を選択。'));
      }

      addressView.appendChild(cityStep.step);
      addressView.appendChild(districtStep.step);
      addressView.appendChild(roadStep.step);
    };

    renderAddressView = () => {
      if (!addressView) return;
      clearChildren(addressView);

      if (!state.data) {
        addressView.appendChild(buildEmptyMessage(state.loadError ? '住所データ読み込みエラー。後ほど再読み込みをお願いします。' : '住所データを読み込んでいます…'));
        return;
      }

      const addressData = getActiveAddressData();

      if (!addressData) {
        addressView.appendChild(buildEmptyMessage('住所データ読み込みエラー。後ほど再読み込みをお願いします。'));
        return;
      }

      if (isJapanAddressMethod(state.activeMethod)) {
        renderJapanAddressView(addressData);
        return;
      }

      const shouldLoadDeliveryRoads =
        isHomeDeliveryMethod(state.activeMethod) &&
        state.addressSelection.city &&
        !hasDeliveryRoadsForCity(addressData, state.addressSelection.city) &&
        !state.deliveryRoadErrors[state.addressSelection.city];

      if (shouldLoadDeliveryRoads) {
        loadDeliveryRoadsForCity(state.addressSelection.city)
          .then(() => {
            if (state.pickerOpen && isHomeDeliveryMethod(state.activeMethod)) renderAddressView();
          })
          .catch(() => {
            if (state.pickerOpen && isHomeDeliveryMethod(state.activeMethod)) renderAddressView();
          });
      }

      const storeCityCacheKey = getStoreCacheKey(state.activeMethod, state.addressSelection.city);
      const shouldLoadStoreCity =
        CONVENIENCE_STORE_METHODS.includes(state.activeMethod) &&
        state.addressSelection.city &&
        !hasStoresForCity(addressData, state.addressSelection.city) &&
        !state.storeFileErrors[storeCityCacheKey];

      if (shouldLoadStoreCity) {
        loadStoresForCity(state.addressSelection.city)
          .then(() => {
            if (state.pickerOpen && CONVENIENCE_STORE_METHODS.includes(state.activeMethod)) renderAddressView();
          })
          .catch(() => {
            if (state.pickerOpen && CONVENIENCE_STORE_METHODS.includes(state.activeMethod)) renderAddressView();
          });
      }

      const cityStep = buildStep('請選擇縣市', {
        isExpanded: state.addressAccordionStep === 'city',
        summary: state.addressSelection.city,
        onToggle: () => toggleAddressAccordionStep('city'),
        columns: 4,
      });
      const districtStep = buildStep('請選擇鄉、鎮、市、區', {
        isExpanded: state.addressAccordionStep === 'district',
        summary: state.addressSelection.districtFull,
        onToggle: () => toggleAddressAccordionStep('district'),
        columns: 3,
      });
      const roadStep = buildStep('請選擇街道', {
        isExpanded: state.addressAccordionStep === 'road',
        summary: state.addressSelection.road,
        onToggle: () => toggleAddressAccordionStep('road'),
        columns: 2,
      });

      addressData.cities.forEach((city) => {
        cityStep.body.appendChild(
          buildChoiceButton(city, state.addressSelection.city === city, () => {
            state.addressSelection.city = city;
            state.addressSelection.districtFull = '';
            state.addressSelection.road = '';
            state.deliveryRoadErrors[city] = false;
            state.storeFileErrors[getStoreCacheKey(state.activeMethod, city)] = false;
            state.addressAccordionStep = 'district';
            renderAddressView();
          })
        );
      });

      if (!addressData.cities.length) {
        cityStep.body.appendChild(buildEmptyMessage('目前沒有可選縣市。'));
      }

      const districts = state.addressSelection.city ? addressData.districtsByCity[state.addressSelection.city] || [] : [];

      if (districts.length) {
        districts.forEach(([district, districtFull]) => {
          districtStep.body.appendChild(
            buildChoiceButton(district, state.addressSelection.districtFull === districtFull, () => {
              state.addressSelection.districtFull = districtFull;
              state.addressSelection.road = '';
              state.addressAccordionStep = 'road';
              renderAddressView();
            })
          );
        });
      } else {
        districtStep.body.appendChild(buildEmptyMessage('請先選擇縣市。'));
      }

      const deliveryRoadsLoading =
        isHomeDeliveryMethod(state.activeMethod) &&
        state.addressSelection.districtFull &&
        state.addressSelection.city &&
        !hasDeliveryRoadsForCity(addressData, state.addressSelection.city) &&
        !state.deliveryRoadErrors[state.addressSelection.city];
      const deliveryRoadsError =
        isHomeDeliveryMethod(state.activeMethod) &&
        state.addressSelection.districtFull &&
        state.addressSelection.city &&
        state.deliveryRoadErrors[state.addressSelection.city];
      const roads = state.addressSelection.districtFull ? addressData.roadsByDistrict[state.addressSelection.districtFull] || [] : [];

      if (roads.length) {
        roads.forEach((road) => {
          roadStep.body.appendChild(
            buildChoiceButton(road, state.addressSelection.road === road, () => {
              if (isHomeDeliveryMethod(state.activeMethod)) {
                selectHomeRoad(road);
              } else {
                state.addressSelection.road = road;
                state.addressAccordionStep = 'store';
                renderAddressView();
              }
            })
          );
        });
      } else if (deliveryRoadsLoading) {
        roadStep.body.appendChild(buildEmptyMessage('正在載入街道資料...'));
      } else if (deliveryRoadsError) {
        roadStep.body.appendChild(buildEmptyMessage('街道資料載入失敗，請稍後再試。'));
      } else if (state.addressSelection.districtFull) {
        roadStep.body.appendChild(buildEmptyMessage('此區域沒有可用街道資料。'));
      } else {
        roadStep.body.appendChild(buildEmptyMessage('請先選擇鄉、鎮、市、區。'));
      }

      addressView.appendChild(cityStep.step);
      addressView.appendChild(districtStep.step);
      addressView.appendChild(roadStep.step);

      if (isHomeDeliveryMethod(state.activeMethod)) {
        return;
      }

      const selectedStoreSummary = getConvenienceStoreSummary(state.activeMethod);
      const storeStep = buildStep('請選擇門市', {
        columns: 1,
        isExpanded: state.addressAccordionStep === 'store',
        summary:
          selectedStoreSummary && selectedStoreSummary.name
            ? `${selectedStoreSummary.name}${selectedStoreSummary.code ? ` (${selectedStoreSummary.code})` : ''}`
            : '',
        onToggle: () => toggleAddressAccordionStep('store'),
      });
      const storeCityLoading =
        state.addressSelection.city &&
        !hasStoresForCity(addressData, state.addressSelection.city) &&
        !state.storeFileErrors[storeCityCacheKey];
      const storeCityError = state.addressSelection.city && state.storeFileErrors[storeCityCacheKey];
      const stores = getStoresForSelectedRoad(addressData);

      if (stores.length) {
        stores.forEach((store) => {
          storeStep.body.appendChild(buildStoreButton(store, selectStore));
        });
      } else if (storeCityLoading) {
        storeStep.body.appendChild(buildEmptyMessage('正在載入門市資料...'));
      } else if (storeCityError) {
        storeStep.body.appendChild(buildEmptyMessage('門市資料載入失敗，請稍後再試。'));
      } else if (state.addressSelection.road) {
        storeStep.body.appendChild(buildEmptyMessage('此條件下沒有可選門市。'));
      } else {
        storeStep.body.appendChild(buildEmptyMessage('請先完成上方地址選擇。'));
      }

      addressView.appendChild(storeStep.step);
    };

    const buildStoreSearchButton = (entry) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cart-store-picker__store';

      const title = document.createElement('div');
      title.className = 'cart-store-picker__store-title';
      title.textContent = `${entry[STORE_SEARCH_INDEX.name] || ''} (${entry[STORE_SEARCH_INDEX.id] || ''})`;

      const address = document.createElement('div');
      address.className = 'cart-store-picker__store-address';
      address.textContent = entry[STORE_SEARCH_INDEX.address] || '';

      button.appendChild(title);
      button.appendChild(address);
      button.addEventListener('click', () => {
        loadStoreForSearchEntry(entry)
          .then((store) => {
            if (store) selectStore(store);
          })
          .catch(() => {
            if (pickerStatus) pickerStatus.textContent = '門市資料載入失敗';
          });
      });

      return button;
    };

    const renderSearchResults = (container, results, emptyText, options = {}) => {
      clearChildren(container);

      if (!results.length) {
        container.appendChild(buildEmptyMessage(emptyText));
        return;
      }

      results.forEach((store) => {
        container.appendChild(options.searchIndex ? buildStoreSearchButton(store) : buildStoreButton(store, selectStore));
      });
    };

    const renderNameView = () => {
      if (!nameView) return;

      let form = nameView.querySelector('.cart-store-picker__search');
      let results = nameView.querySelector('.cart-store-picker__results');

      if (!form || !results) {
        clearChildren(nameView);
        form = document.createElement('div');
        form.className = 'cart-store-picker__search';
        if (nameInput) form.appendChild(nameInput);
        results = document.createElement('div');
        results.className = 'cart-store-picker__results';
        nameView.appendChild(form);
        nameView.appendChild(results);
      }

      clearChildren(results);

      if (!state.data) {
        results.appendChild(buildEmptyMessage(state.loadError ? '門市資料載入失敗，請稍後再試。' : '正在載入門市資料...'));
      } else {
        const chainData = getChainData();

        if (!chainData) {
          results.appendChild(buildEmptyMessage('門市資料載入失敗，請稍後再試。'));
        } else {
          const query = normalizeText(nameInput ? nameInput.value : '');

          if (!query) {
            results.appendChild(buildEmptyMessage('請輸入門市名稱或地址。'));
          } else if (Array.isArray(chainData.stores)) {
            const matches = chainData.stores
              .filter((store) => normalizeText(`${store[STORE_INDEX.name]}${store[STORE_INDEX.address]}${store[STORE_INDEX.id]}`).includes(query))
              .slice(0, 80);

            renderSearchResults(results, matches, '找不到符合條件的門市。');
          } else {
            const cacheKey = `${state.activeMethod}|search`;

            if (!Array.isArray(chainData.searchStores)) {
              if (!state.storeSearchLoading && !state.storeSearchErrors[cacheKey]) {
                state.storeSearchLoading = true;
                loadStoreSearchIndex()
                  .then(() => {
                    state.storeSearchLoading = false;
                    if (state.pickerOpen && state.activeTab === 'name' && CONVENIENCE_STORE_METHODS.includes(state.activeMethod)) renderNameView();
                  })
                  .catch(() => {
                    state.storeSearchLoading = false;
                    if (state.pickerOpen && state.activeTab === 'name' && CONVENIENCE_STORE_METHODS.includes(state.activeMethod)) renderNameView();
                  });
              }

              results.appendChild(buildEmptyMessage(state.storeSearchErrors[cacheKey] ? '門市搜尋資料載入失敗，請稍後再試。' : '正在載入門市搜尋資料...'));
              return;
            }

            const matches = chainData.searchStores
              .filter((store) =>
                normalizeText(
                  `${store[STORE_SEARCH_INDEX.name]}${store[STORE_SEARCH_INDEX.address]}${store[STORE_SEARCH_INDEX.id]}`
                ).includes(query)
              )
              .slice(0, 80);

            renderSearchResults(results, matches, '找不到符合條件的門市。', { searchIndex: true });
          }
        }
      }
    };

    const renderCodeView = () => {
      if (!codeView) return;

      let form = codeView.querySelector('.cart-store-picker__search');
      let results = codeView.querySelector('.cart-store-picker__results');

      if (!form || !results) {
        clearChildren(codeView);
        form = document.createElement('div');
        form.className = 'cart-store-picker__search';
        if (codeInput) form.appendChild(codeInput);
        results = document.createElement('div');
        results.className = 'cart-store-picker__results';
        codeView.appendChild(form);
        codeView.appendChild(results);
      }

      clearChildren(results);

      if (!state.data) {
        results.appendChild(buildEmptyMessage(state.loadError ? '門市資料載入失敗，請稍後再試。' : '正在載入門市資料...'));
      } else {
        const chainData = getChainData();
        const query = normalizeText(codeInput ? codeInput.value : '');

        if (!chainData) {
          results.appendChild(buildEmptyMessage('門市資料載入失敗，請稍後再試。'));
        } else if (!query) {
          results.appendChild(buildEmptyMessage('請輸入門市編號。'));
        } else if (Array.isArray(chainData.stores)) {
          const matches = chainData.stores
            .filter((store) => normalizeText(store[STORE_INDEX.id]).includes(query))
            .slice(0, 80);

          renderSearchResults(results, matches, '找不到符合條件的門市編號。');
        } else {
          const cacheKey = `${state.activeMethod}|search`;

          if (!Array.isArray(chainData.searchStores)) {
            if (!state.storeSearchLoading && !state.storeSearchErrors[cacheKey]) {
              state.storeSearchLoading = true;
              loadStoreSearchIndex()
                .then(() => {
                  state.storeSearchLoading = false;
                  if (state.pickerOpen && state.activeTab === 'code') renderCodeView();
                })
                .catch(() => {
                  state.storeSearchLoading = false;
                  if (state.pickerOpen && state.activeTab === 'code') renderCodeView();
                });
            }

            results.appendChild(buildEmptyMessage(state.storeSearchErrors[cacheKey] ? '門市搜尋資料載入失敗，請稍後再試。' : '正在載入門市搜尋資料...'));
            return;
          }

          const matches = chainData.searchStores
            .filter((store) => normalizeText(store[STORE_SEARCH_INDEX.id]).includes(query))
            .slice(0, 80);

          renderSearchResults(results, matches, '找不到符合條件的門市編號。', { searchIndex: true });
        }
      }
    };

    const buildDeliveryResultButton = (city, districtFull, road, onSelect) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cart-store-picker__store';

      const title = document.createElement('div');
      title.className = 'cart-store-picker__store-title';
      title.textContent = `${city} ${districtFull}`;

      const address = document.createElement('div');
      address.className = 'cart-store-picker__store-address';
      address.textContent = road || '';

      button.appendChild(title);
      if (road) button.appendChild(address);
      button.addEventListener('click', () => onSelect(city, districtFull, road));

      return button;
    };

    const buildJapanAddressButton = (address, onSelect = selectJapanAddress) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cart-store-picker__store';

      const postalCode = address[JAPAN_ADDRESS_INDEX.postalCode] || '';
      const province = address[JAPAN_ADDRESS_INDEX.province] || '';
      const city = address[JAPAN_ADDRESS_INDEX.city] || '';
      const district = address[JAPAN_ADDRESS_INDEX.district] || '';

      const title = document.createElement('div');
      title.className = 'cart-store-picker__store-title';
      title.textContent = postalCode ? `〒${postalCode} ${province}${city}` : `${province}${city}`;

      const addressText = document.createElement('div');
      addressText.className = 'cart-store-picker__store-address';
      addressText.textContent = district;

      button.appendChild(title);
      button.appendChild(addressText);
      button.addEventListener('click', () => onSelect(address));

      return button;
    };

    const renderHomeDeliveryNameView = () => {
      if (!nameView) return;

      let form = nameView.querySelector('.cart-store-picker__search');
      let results = nameView.querySelector('.cart-store-picker__results');

      if (!form || !results) {
        clearChildren(nameView);
        form = document.createElement('div');
        form.className = 'cart-store-picker__search';
        if (nameInput) form.appendChild(nameInput);
        results = document.createElement('div');
        results.className = 'cart-store-picker__results';
        nameView.appendChild(form);
        nameView.appendChild(results);
      }

      clearChildren(results);

      if (!state.data) {
        results.appendChild(buildEmptyMessage(state.loadError ? '住所データ読み込みエラー。後ほど再読み込みをお願いします。' : '住所データを読み込んでいます…'));
      } else {
        const addressData = getActiveAddressData();
        const query = normalizeText(nameInput ? nameInput.value : '');

        if (!query) {
          results.appendChild(buildEmptyMessage('請輸入地址關鍵字。'));
        } else {
          const allRoadsLoaded = hasAllDeliveryRoads(addressData);
          const hasRoadLoadError = (addressData.cities || []).some((city) => state.deliveryRoadErrors[city]);

          if (!allRoadsLoaded) {
            if (!state.deliverySearchRoadsLoading && !hasRoadLoadError) {
              state.deliverySearchRoadsLoading = true;
              loadAllDeliveryRoads()
                .then(() => {
                  state.deliverySearchRoadsLoading = false;
                  if (state.pickerOpen && isHomeDeliveryMethod(state.activeMethod) && state.activeTab === 'name') renderHomeDeliveryNameView();
                })
                .catch(() => {
                  state.deliverySearchRoadsLoading = false;
                  if (state.pickerOpen && isHomeDeliveryMethod(state.activeMethod) && state.activeTab === 'name') renderHomeDeliveryNameView();
                });
            }

            results.appendChild(buildEmptyMessage(hasRoadLoadError ? '街道資料載入失敗，請稍後再試。' : '住所データを読み込んでいます…'));
            return;
          }

          const matches = [];
          const seen = new Set();

          addressData.cities.forEach((city) => {
            const districts = addressData.districtsByCity[city] || [];
            districts.forEach(([district, districtFull]) => {
              const roads = addressData.roadsByDistrict[districtFull] || [];
              if (roads.length === 0) {
                const key = `${city}|${districtFull}|`;
                if (!seen.has(key) && normalizeText(`${city}${districtFull}`).includes(query)) {
                  seen.add(key);
                  matches.push({ city, districtFull, road: '' });
                }
              } else {
                roads.forEach((road) => {
                  const key = `${city}|${districtFull}|${road}`;
                  if (!seen.has(key) && normalizeText(`${city}${districtFull}${road}`).includes(query)) {
                    seen.add(key);
                    matches.push({ city, districtFull, road });
                  }
                });
              }
            });
          });

          const limited = matches.slice(0, 80);
          if (!limited.length) {
            results.appendChild(buildEmptyMessage('找不到符合條件的地址。'));
          } else {
            limited.forEach(({ city, districtFull, road }) => {
              results.appendChild(
                buildDeliveryResultButton(city, districtFull, road, (c, d, r) => {
                  state.addressSelection = { city: c, districtFull: d, road: r };
                  if (deliveryCityInput) deliveryCityInput.value = c;
                  if (deliveryDistrictInput) deliveryDistrictInput.value = d;
                  if (deliveryRoadInput) deliveryRoadInput.value = r;

                  setDeliveryAddressValue();
                  const homeSummary = getHomeSummary();
                  state.homeDelivery = homeSummary;
                  persistShippingState();

                  clearValidationState();
                  state.expanded = true;
                  updateState();
                  closePicker();

                  if (homeDetailInput) {
                    homeDetailInput.focus();
                  }
                })
              );
            });
          }
        }
      }
    };

    const renderJapanAddressNameView = () => {
      if (!nameView) return;

      let form = nameView.querySelector('.cart-store-picker__search');
      let results = nameView.querySelector('.cart-store-picker__results');

      if (!form || !results) {
        clearChildren(nameView);
        form = document.createElement('div');
        form.className = 'cart-store-picker__search';
        if (nameInput) form.appendChild(nameInput);
        results = document.createElement('div');
        results.className = 'cart-store-picker__results';
        nameView.appendChild(form);
        nameView.appendChild(results);
      }

      clearChildren(results);

      if (!state.data) {
        results.appendChild(buildEmptyMessage(state.loadError ? '住所データ読み込みエラー。後ほど再読み込みをお願いします。' : '住所データを読み込んでいます…'));
        return;
      }

      const addressData = getActiveAddressData();
      const query = normalizeText(nameInput ? nameInput.value : '');
      const province = state.addressSelection.city;

      if (!addressData) {
        results.appendChild(buildEmptyMessage('住所データ読み込みエラー。後ほど再読み込みをお願いします。'));
        return;
      }

      if (!query) {
        results.appendChild(buildEmptyMessage('郵便番号または住所キーワードをご入力ください。'));
        return;
      }

      if (!province) {
        results.appendChild(buildEmptyMessage('住所検索にて先に都道府県を選択。'));
        return;
      }

      const provinceFileError = state.japanAddressFileErrors[province];

      if (!hasJapanAddressesForProvince(addressData, province)) {
        if (!provinceFileError) {
          loadJapanAddressesForProvince(province)
            .then(() => {
              if (state.pickerOpen && isJapanAddressMethod(state.activeMethod) && state.activeTab === 'name') renderJapanAddressNameView();
            })
            .catch(() => {
              if (state.pickerOpen && isJapanAddressMethod(state.activeMethod) && state.activeTab === 'name') renderJapanAddressNameView();
            });
        }

        results.appendChild(buildEmptyMessage(provinceFileError ? '町域データ読み込みエラー。後ほど再読み込みをお願いします。' : '町域データ読み込み中…'));
        return;
      }

      const matches = (addressData.addressesByProvince[province] || [])
        .filter((address) =>
          normalizeText(
            `${address[JAPAN_ADDRESS_INDEX.postalCode]}${address[JAPAN_ADDRESS_INDEX.province]}${address[JAPAN_ADDRESS_INDEX.city]}${address[JAPAN_ADDRESS_INDEX.district]}`
          ).includes(query)
        )
        .slice(0, 80);

      if (!matches.length) {
        results.appendChild(buildEmptyMessage('条件に該当する住所が見つかりません。'));
        return;
      }

      matches.forEach((address) => {
        results.appendChild(buildJapanAddressButton(address));
      });
    };

    const renderActiveView = () => {
      if (state.activeTab === 'address') {
        renderAddressView();
        return;
      }

      if (state.activeTab === 'name') {
        if (isJapanAddressMethod(state.activeMethod)) {
          renderJapanAddressNameView();
        } else if (isHomeDeliveryMethod(state.activeMethod)) {
          renderHomeDeliveryNameView();
        } else {
          renderNameView();
        }
        return;
      }

      renderCodeView();
    };

    let preloadSelectionFromSummary = () => {
      if (isHomeDeliveryMethod(state.activeMethod)) {
        state.addressSelection = {
          city: deliveryCityInput ? deliveryCityInput.value.trim() : '',
          districtFull: deliveryDistrictInput ? deliveryDistrictInput.value.trim() : '',
          road: deliveryRoadInput ? deliveryRoadInput.value.trim() : '',
        };
        return;
      }

      const summary = getConvenienceStoreSummary(state.activeMethod);
      const chainData = getChainData();

      if (!summary || !chainData) {
        state.addressSelection = { city: '', districtFull: '', road: '' };
        return;
      }

      const matchedStore = findStoreInChainData(chainData, summary.code, summary.address);

      state.addressSelection = {
        city: (matchedStore && matchedStore[STORE_INDEX.city]) || summary.city || '',
        districtFull: (matchedStore && matchedStore[STORE_INDEX.districtFull]) || summary.districtFull || '',
        road: (matchedStore && matchedStore[STORE_INDEX.road]) || summary.road || '',
      };
    };

    preloadSelectionFromSummary = () => {
      if (isHomeDeliveryMethod(state.activeMethod)) {
        state.addressSelection = {
          city: deliveryCityInput ? deliveryCityInput.value.trim() : '',
          districtFull: deliveryDistrictInput ? deliveryDistrictInput.value.trim() : '',
          road: deliveryRoadInput ? deliveryRoadInput.value.trim() : '',
        };
        state.addressAccordionStep = getDefaultAddressAccordionStep();
        return;
      }

      if (isJapanAddressMethod(state.activeMethod)) {
        const summary = getJapanAddressSummary() || state.japanAddress;
        state.addressSelection = summary
          ? {
              city: summary.province || '',
              districtFull: summary.cityFull || '',
              road: summary.fullAddress || '',
            }
          : { city: '', districtFull: '', road: '' };
        state.addressAccordionStep = getDefaultAddressAccordionStep();
        return;
      }

      const summary = getConvenienceStoreSummary(state.activeMethod);
      const chainData = getChainData();

      if (!summary || !chainData) {
        state.addressSelection = { city: '', districtFull: '', road: '' };
        state.addressAccordionStep = getDefaultAddressAccordionStep();
        return;
      }

      const matchedStore = findStoreInChainData(chainData, summary.code, summary.address);

      state.addressSelection = {
        city: (matchedStore && matchedStore[STORE_INDEX.city]) || summary.city || '',
        districtFull: (matchedStore && matchedStore[STORE_INDEX.districtFull]) || summary.districtFull || '',
        road: (matchedStore && matchedStore[STORE_INDEX.road]) || summary.road || '',
      };
      state.addressAccordionStep = getDefaultAddressAccordionStep();
    };

    const openPicker = (method, triggerButton) => {
      const requestId = state.requestId + 1;
      state.requestId = requestId;
      state.activeMethod = method;
      state.pickerOpen = true;
      state.lastTrigger = triggerButton || null;

      picker.classList.add('is-open');
      picker.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      syncPickerTabs(method);

      const config = getMethodConfig(method);

      if (pickerTitle) {
        pickerTitle.textContent = config.pickerTitle;
      }

      if (pickerStatus) {
        pickerStatus.textContent = config.pickerStatus;
      }

      state.activeTab = 'address';
      if (nameInput) {
        nameInput.value = '';
        nameInput.placeholder = isJapanAddressMethod(method)
          ? '郵便番号・都道府県・市区町村・町域を入力'
          : isHomeDeliveryMethod(method)
            ? '都道府県 / 市区町村 / 町域を入力'
            : '店舗名 / 住所を入力';
      }
      if (codeInput) codeInput.value = '';

      state.data = null;
      state.loadError = false;
      state.deliverySearchRoadsLoading = false;

      loadMethodData(picker, method)
        .then((data) => {
          if (!state.pickerOpen || state.requestId !== requestId || state.activeMethod !== method) return;

          state.data = data;
          state.loadError = false;
          state.deliveryRoadErrors = {};
          state.japanAddressFileErrors = {};
          state.storeFileErrors = {};
          state.storeSearchErrors = {};
          state.storeSearchLoading = false;

          preloadSelectionFromSummary();

          const selectionDataReady =
            isJapanAddressMethod(method) && state.addressSelection.city
              ? loadJapanAddressesForProvince(state.addressSelection.city).catch(() => null)
              : isHomeDeliveryMethod(method) && state.addressSelection.city
              ? loadDeliveryRoadsForCity(state.addressSelection.city).catch(() => null)
              : state.addressSelection.city
                ? loadStoresForCity(state.addressSelection.city).catch(() => null)
                : Promise.resolve();

          // Validate saved selections against current data and clear stale entries
          validateSavedSelections(data);

          setActiveTab('address');
          pickerPanel.focus();

          selectionDataReady.then(() => {
            if (!state.pickerOpen || state.requestId !== requestId || state.activeMethod !== method) return;
            validateSavedSelections(data);
            renderActiveView();
          });
        })
        .catch(() => {
          if (!state.pickerOpen || state.requestId !== requestId || state.activeMethod !== method) return;

          if (pickerStatus) {
            pickerStatus.textContent = isAddressDeliveryMethod(method) ? '住所データ読み込みエラー' : '店舗データ読み込みエラー';
          }
          state.data = null;
          state.loadError = true;
          renderActiveView();
        });

      renderActiveView();
    };

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (state.pickerOpen && getSelectedMethod() !== state.activeMethod) {
          closePicker();
        }

        clearValidationState();
        state.expanded = true;
        syncAddressInputsForMethod(getSelectedMethod());
        updateState();
        // Save selected method while preserving address data for all methods.
        persistShippingState();
      });
    });

    triggerButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const row = button.closest('[data-shipping-option]');
        const radio = row ? row.querySelector('input[type="radio"]') : null;

        if (!row || !radio) return;

        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          clearValidationState();
          state.expanded = true;
          updateState();
        }

        clearValidationState();
        openPicker(row.dataset.shippingValue, button);
      });
    });

    pickerCloseButtons.forEach((button) => {
      button.addEventListener('click', closePicker);
    });

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.hidden) return;
        setActiveTab(button.dataset.storePickerTabButton);
      });
    });

    if (nameInput) {
      nameInput.addEventListener('input', () => {
        if (state.activeTab === 'name') {
          if (isJapanAddressMethod(state.activeMethod)) {
            renderJapanAddressNameView();
          } else if (isHomeDeliveryMethod(state.activeMethod)) {
            renderHomeDeliveryNameView();
          } else {
            renderNameView();
          }
        }
      });
    }

    if (codeInput) {
      codeInput.addEventListener('input', () => {
        if (state.activeTab === 'code') {
          renderCodeView();
        }
      });
    }

    if (deliveryPostalCodeInput) {
      deliveryPostalCodeInput.addEventListener('input', normalizeJapanPostalCodeInput);
    }

    if (deliveryPostalCodeSearchButton) {
      deliveryPostalCodeSearchButton.addEventListener('click', handleJapanPostalCodeSearch);
    }

    [japanProvinceDisplay, japanCityDisplay, japanTownDisplay, japanPostalDisplay].forEach((input) => {
      if (!input) return;

      input.addEventListener('input', () => {
        if (input === japanPostalDisplay) {
          syncJapanPostalInputs(japanPostalDisplay.value, japanPostalDisplay);
        }

        clearValidationState();
        setDeliveryAddressValue();
        syncShippingPayload();
        syncSelectedHomeCard();
        const selectedMethod = getSelectedMethod();
        syncHint(selectedMethod);
        syncActionButtons(selectedMethod);

        if (isJapanAddressMethod(selectedMethod)) {
          state.japanAddress = getJapanAddressSummary();
          if (state.japanAddress) persistShippingState();
        }
      });
    });

    if (homeDetailInput) {
      homeDetailInput.addEventListener('input', () => {
        clearValidationState();
        setDeliveryAddressValue();
        syncShippingPayload();
        syncSelectedHomeCard();
        const selectedMethod = getSelectedMethod();
        syncHint(selectedMethod);
        syncActionButtons(selectedMethod);

        if (isJapanAddressMethod(selectedMethod)) {
          state.japanAddress = getJapanAddressSummary();
          if (state.japanAddress) persistShippingState();
        } else if (isHomeDeliveryMethod(selectedMethod)) {
          state.homeDelivery = getHomeSummary();
          if (state.homeDelivery) persistShippingState();
        }
      });
    }


    [
      ['name', contactNameInput],
      ['phone', contactPhoneInput],
      ['email', contactEmailInput],
    ].forEach(([fieldName, input]) => {
      if (!input) return;

      input.addEventListener('input', () => {
        clearContactFieldError(fieldName);
        syncContactCheckoutInputs();
        saveContactInfo();
      });

      input.addEventListener('change', () => {
        syncContactCheckoutInputs();
        saveContactInfo();
      });

      input.addEventListener('blur', () => {
        const contact = getContactInfo();
        const nameCharacters = contact.name.replace(/\s+/g, '');

        if (fieldName === 'name' && contact.name && (nameCharacters.length < 2 || /\d/.test(contact.name))) {
          showContactError('name', 'お名前を2文字以上で入力してください。数字は使用できません。', { focus: false });
        }
        if (fieldName === 'phone' && contact.phone && !isValidJapanPhone(contact.phone)) {
          showContactError('phone', '有効な日本の電話番号を入力してください。例：09012345678、03-1234-5678、+819012345678', { focus: false });
        }
        if (fieldName === 'email' && contact.email && !isValidEmail(contact.email)) {
          showContactError('email', 'メールアドレスの形式またはドメインが正しくありません。例：name@gmail.com', { focus: false });
        }
      });
    });

    checkoutButtons.forEach((button) => {
      button.addEventListener('click', beginCheckout);
    });

    // Re-enable checkout buttons when the page becomes visible again.
    // Uses multiple events as fallbacks since pageshow alone is unreliable on mobile.
    const recoverCheckoutState = () => {
      if (!state.checkoutSubmitting) return;
      state.checkoutSubmitting = false;
      setCheckoutButtonsDisabled(false);
    };

    window.addEventListener('pageshow', recoverCheckoutState);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') recoverCheckoutState();
    });
    window.addEventListener('focus', recoverCheckoutState);

    picker.addEventListener('keydown', (event) => {
      if (!state.pickerOpen || event.key !== 'Escape') return;
      closePicker();
    });

    picker.addEventListener('click', (event) => {
      if (!state.pickerOpen || event.target !== picker) return;
      closePicker();
    });

    updateState();
    prefetchMethodIndexes(picker, getSelectedMethod());
  }

  function initAll() {
    document.querySelectorAll('[data-cart-shipping-selector]').forEach(initRoot);
  }

  function scheduleInit() {
    if (initFrame) return;

    initFrame = window.requestAnimationFrame(() => {
      initFrame = null;
      initAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (!window.__cartStorePickerObserver) {
    window.__cartStorePickerObserver = new MutationObserver(scheduleInit);
    window.__cartStorePickerObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

})();
